import {ANNOTATION_VIDEO_DISPLAY, ANNOTATION_PARENT, VIDEO_PLAYING_MODE, ANNOTATION_LOCATION} from './GlobalConstants';
import * as THREE from 'three';

export const ANNOTATION_CONTACT_TEXT = '';
export const CONTACT_URL = 'WEBSITE';
export const YOUTUBE = 'YOUTUBE';
export const INSTAGRAM = 'INSTAGRAM';
export const SPOTIFY = 'SPOTIFY';
export const TWITTER = 'TWITTER';
export const TIKTOK = 'TIKTOK';
export const IMDB = 'IMDB';
export const FACEBOOK = 'FACEBOOK';
export const ENQUIRE_EMAIL = 'ENQUIRE';
export const LINKED_IN = 'LINKEDIN';
export const HAS_MEDIA_CAROUSEL_LINK = 'MORE';
export const SEND_TO_EMAIL = 'SEND TO';


export const CANTALOUPE_IMAGE_SERVER = "https://iiif.v21artspace.com/iiif/2/shedecides%2F2021%2F";

export const ANNOTATION_TEXT_ALIGNMENT = "justify";
export const ANNOTATION_TEXT_LINE_HEIGHT = "1.5";
export const GALLERY_LINK_LABEL = "ARTIST-PROFILE";
// export const GALLERY_LINK_LABEL = `<img src='/assets/languages/iconfinder_uk.png'>`;


const AnnotationsDB = [

    // {
    //     paintingId: '',
    //     videoId: null,
    //     videoURL: null,
    //     hasCarouselAsParent: 'Y',
    //     carouselAnnotationSiblings: ['EN', 'FR', 'ES'],
    // },
    // {
    //     paintingId: 'EN',
    //     videoId: null,
    //     videoURL: null,
    //     iiifSource: `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`,
    //     headerText: `<h5></h5><h6></h6>`,
    //     bodyText: `<b>ENG/US</b> <i></i><br><br>`,
    //     // instagramUrl: '',
    //     // facebookUrl: '',
    //     // ContactURL: '',
    // },
    // {
    //     paintingId: 'FR',
    //     videoId: null,
    //     videoURL: null,
    //     iiifSource: `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`,
    //     headerText: `<h5></h5><h6></h6>`,
    //     bodyText: `<b>FR</b> <i></i><br><br>`,
    //     // instagramUrl: '',
    //     // facebookUrl: '',
    //     // ContactURL: '',
    // },
    // {
    //     paintingId: 'ES',
    //     videoId: null,
    //     videoURL: null,
    //     iiifSource: `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`,
    //     headerText: `<h5></h5><h6></h6>`,
    //     bodyText: `<b>ES</b> <i></i><br><br>`,
    //     // instagramUrl: '',
    //     // facebookUrl: '',
    //     // ContactURL: '',
    // },

    /* Video */
    {
        paintingId: 'W01V01',
        videoId: 'W01V01',
        standaloneVideoElementId: 'W01V01',
        videoURL: 'W01V01.mp4',
        headerText: `<h5></h5>`,
        bodyText: ``,
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE | ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
        displayMesh: 'N',
        // displayHeight: 90,
        videoAutoPlay: 'N',
        // videoPlaySpriteImageURL: '/assets/sprites/videoPlayButtonBlack.svg',
        // videoPauseSpriteImageURL: '/assets/sprites/videoPauseButtonBlack.svg',
        // videoButtonScale: {x: .2, y: .2, z: .2},
        // videoButtonPos:{x:9.17728, y:0.606917,z:11.6652},
        videoTextureEncoding: THREE.sRGBEncoding,
        // videoButtonPos:{x:-8.31443,y:-1.5 ,z:-29.7395 }
        useVideoMeshButton: 'Y',
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['W01V01INS', 'W01V01EN', 'W01V01FR', 'W01V01ES'],
    },
    {
        paintingId: 'W01V01INS',
        videoId: null,
        videoURL: 'W01V01.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
        headerText: null,
        bodyText: `<b>ENG/US</b> Click the yellow arrows to move between languages<br><b>FR</b> Cliquez sur les flèches jaunes pour déplacer entre les langues<br><b>ES</b> Haga clic en las flechas amarillas para moverse entre idiomas`,
    },
    {
        paintingId: 'W01V01EN',
        videoId: null,
        videoURL: 'W01V01.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
        headerText: `<h5>SheDecides</h5>`,
        bodyText: `<b>ENG/US</b> <i>When She Decides The world is better, stronger, safer</i><br><br>The SheDecides movement disrupts the power imbalances that for too long have stopped girls and women from deciding. Energized by evidence-based outrage, we are a conspiracy of hope. Sign the Manifesto. Join the Movement`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        urlLink1Label: 'MANIFESTO',
        urlLink1: 'https://www.shedecides.com/manifesto/',
    },
    {
        paintingId: 'W01V01FR',
        videoId: null,
        videoURL: 'W01V01.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
        headerText: `<h5>SheDecides</h5>`,
        bodyText: `<b>FR</b> <i>Quand C’est Elle qui Décide, le monde est un endroit plus sain, solide et sûr</i><br><br>Le mouvement SheDecides vise à corriger les déséquilibres de pouvoir qui ont trop longtemps empêché les filles et les femmes de gouverner leurs vies.  Dynamisés par une indignation fondée sur des preuves, nous sommes une conspiration d'espoir. Signez notre Manifeste. Ralliez-vous à notre mouvement`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        urlLink1Label: 'MANIFESTE',
        urlLink1: 'https://www.shedecides.com/wp-content/uploads/2018/12/SheDecidesManifestoFrench-1.pdf',
    },
    {
        paintingId: 'W01V01ES',
        videoId: null,
        videoURL: 'W01V01.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
        headerText: `<h5>SheDecides</h5>`,
        bodyText: `<b>ES</b> <i>Si ella decide, el mundo será un lugar más bello, fuerte y seguro</i><br><br>El movimiento SheDecides tumba el desequilibrio de poder que durante demasiado tiempo ha impedido que las niñas y las mujeres decidan.  Gracias a la indignación que se basa en la evidencia, conspiramos por la esperanza. Firma el manifiesto. Únete al movimiento`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        urlLink1Label: 'MANIFIESTO',
        urlLink1: 'https://www.shedecides.com/wp-content/uploads/2018/12/SheDecidesManifestoSpanish-1.pdf',
    },

    {
        paintingId: 'W05V01',
        videoId: 'W05V01',
        standaloneVideoElementId: 'W05V01',
        videoURL: 'W05V01.mp4',
        // headerText: `<h5></h5>`,
        // bodyText: ``,
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE | ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
        displayMesh: 'N',
        // displayHeight: 90,
        videoAutoPlay: 'N',
        // videoPlaySpriteImageURL: '/assets/sprites/videoPlayButtonBlack.svg',
        // videoPauseSpriteImageURL: '/assets/sprites/videoPauseButtonBlack.svg',
        // videoButtonScale: {x: .2, y: .2, z: .2},
        // videoButtonPos:{x:9.17728, y:0.606917,z:11.6652},
        videoTextureEncoding: THREE.sRGBEncoding,
        // videoButtonPos:{x:-8.31443,y:-1.5 ,z:-29.7395 }
        useVideoMeshButton: 'Y',
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['W05V01INS', 'W05V01EN', 'W05V01FR', 'W05V01ES'],
    },
    {
        paintingId: 'W05V01INS',
        videoId: null,
        videoURL: 'W05V01.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
        headerText: null,
        bodyText: `<b>ENG/US</b> Click the yellow arrows to move between languages<br><b>FR</b> Cliquez sur les flèches jaunes pour déplacer entre les langues<br><b>ES</b> Haga clic en las flechas amarillas para moverse entre idiomas`,
    },
    {
        paintingId: 'W05V01EN',
        videoId: null,
        videoURL: 'W05V01.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
        headerText: `<h5>Tanzila Khan</h5><h6>(She/Her)</h6>`,
        bodyText: `<b>ENG/US</b> <i>Tanzila</i> is an author, trainer, speaker and founder of Girlythings.pk through which she delivers sanitary napkins and other period products to women anywhere in Pakistan. She is also a filmmaker and actor.<br><br>This short film, Fruit Chaat, is the story of a disabled girl Shabana who has received her degree but is held back from career opportunities by the stigma around disability. It is comical and satirical and deals with major themes including education, employment, entrepreneurship and love.`,
        instagramUrl: 'https://www.instagram.com/itanzilakhan/?hl=en ',
        // facebookUrl: '',
        // ContactURL: '',
    },
    {
        paintingId: 'W05V01FR',
        videoId: null,
        videoURL: 'W05V01.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
        headerText: `<h5>Tanzila Khan</h5><h6>(She/Her)</h6>`,
        bodyText: `<b>FR</b> <i>Tanzila</i> est auteure, formatrice, conférencière et fondatrice du site Girlythings.pk à travers lequel elle fournit des serviettes hygiéniques et d'autres produits pour les menstruations aux femmes du Pakistan. Elle est également cinéaste et actrice.<br><br>Ce court métrage, Fruit Chaat, raconte l’histoire d’une jeune fille handicapée qui a obtenu son diplôme mais dont la carrière professionnelle est entravée à cause de la stigmatisation liée à son handicap. Le film est à la fois comique et satirique et traite de grands thèmes comme l'éducation, l'emploi, l'entrepreneuriat et l'amour.`,
        instagramUrl: 'https://www.instagram.com/itanzilakhan/?hl=en ',
        // facebookUrl: '',
        // ContactURL: '',
    },
    {
        paintingId: 'W05V01ES',
        videoId: null,
        videoURL: 'W05V01.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
        headerText: `<h5>Tanzila Khan</h5><h6>(She/Her)</h6>`,
        bodyText: `<b>ES</b> <i>Tanzila</i> es autora, formadora, conferenciante y fundadora de Girlythings.pk, que utiliza para repartir compresas y otros productos necesarios para la menstruación a mujeres por todo Pakistán. También es directora de cine y actriz.<br><br>Este cortometraje, Fruit Chaat, es la historia de una chica discapacitada, Shabana, que se ha graduado, pero no puede desarrollar su carrera profesional por el estigma que rodea a la discapacidad. Es una historia cómica y satírica que aborda temas más importantes como educación, empleo, emprendimiento y amor.`,
        instagramUrl: 'https://www.instagram.com/itanzilakhan/?hl=en ',
        // facebookUrl: '',
        // ContactURL: '',
    },


    {
        paintingId: 'W08V01',
        videoId: 'W08V01',
        standaloneVideoElementId: 'W08V01',
        videoURL: 'W08V01.mp4',
        // headerText: `<h5></h5>`,
        // bodyText: ``,
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE | ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
        displayMesh: 'N',
        // displayHeight: 90,
        videoAutoPlay: 'N',
        // videoPlaySpriteImageURL: '/assets/sprites/videoPlayButtonBlack.svg',
        // videoPauseSpriteImageURL: '/assets/sprites/videoPauseButtonBlack.svg',
        // videoButtonScale: {x: .2, y: .2, z: .2},
        // videoButtonPos:{x:9.17728, y:0.606917,z:11.6652},
        videoTextureEncoding: THREE.sRGBEncoding,
        // videoButtonPos:{x:-8.31443,y:-1.5 ,z:-29.7395 }
        useVideoMeshButton: 'Y',
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['W08V01INS', 'W08V01EN', 'W08V01FR', 'W08V01ES'],
    },
    {
        paintingId: 'W08V01INS',
        videoId: null,
        videoURL: 'W08V01.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
        headerText: null,
        bodyText: `<b>ENG/US</b> Click the yellow arrows to move between languages<br><b>FR</b> Cliquez sur les flèches jaunes pour déplacer entre les langues<br><b>ES</b> Haga clic en las flechas amarillas para moverse entre idiomas`,
    },
    {
        paintingId: 'W08V01EN',
        videoId: null,
        videoURL: 'W08V01.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
        headerText: `<h5>Laraib Abid</h5><h6>(She/Her)</h6>`,
        bodyText: `<b>ENG/US</b> <i>Laraib</i> is a feminist, lecturer and founder of MASHAL - a women-led youth organisation working for sexual and reproductive health and rights.<br><br>This video piece depicts the blame culture placed on women and their clothes when they are sexually harassed. It shows a woman that adds one more layer of clothes everyday but still experiences the same levels of harassment.<br><br>Laraib says: "In the video, one day the woman sees a father raping his son and this sends the message that we need to change our mentality, and not our clothes."`,
        // instagramUrl: '',
        // facebookUrl: '',
        ContactURL: 'https://beamashal.com/',
    },
    {
        paintingId: 'W08V01FR',
        videoId: null,
        videoURL: 'W08V01.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
        headerText: `<h5>Laraib Abid</h5><h6>(She/Her)</h6>`,
        bodyText: `<b>FR</b> <i>Laraib</i> est féministe, conférencière et fondatrice du projet MASHAL — une organisation de jeunesse régie par des femmes qui cherche à assurer le respect des droits en matière de santé génésique et sexuelle.<br><br>Cette vidéo montre la culture de la culpabilisation des femmes et la façon dont elles sont vêtues lorsqu'elles sont harcelées sexuellement. Cette pièce montre une femme qui ajoute une couche supplémentaire de vêtements tous les jours mais qui continue de subir un même harcèlement.<br><br>Laraib signale : « Dans la vidéo, la femme voit un père en train de violer son fils et cela nous envoie le message que nous devons changer notre mentalité, pas nos vêtements ».`,
        // instagramUrl: '',
        // facebookUrl: '',
        ContactURL: 'https://beamashal.com/',
    },
    {
        paintingId: 'W08V01ES',
        videoId: null,
        videoURL: 'W08V01.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
        headerText: `<h5>Laraib Abid</h5><h6>(She/Her)</h6>`,
        bodyText: `<b>ES</b> <i>Laraib</i> es feminista, profesora y fundadora de MASHAL, una organización juvenil dirigida por mujeres que defiende la salud sexual y reproductiva así como sus derechos.<br><br>Este fragmento de vídeo muestra la cultura de la culpa que se atribuye a las mujeres y a la ropa que llevan cuando se las acosa sexualmente. Aparece a una mujer que todos los días se pone una capa más de ropa, pero que sigue sufriendo el mismo nivel de acoso.<br><br>Según declara Laraib: "En el vídeo, un día la mujer ve a un padre violando a su hijo, el mensaje que envía es que tenemos que cambiar nuestra mentalidad, no nuestra ropa".`,
        // instagramUrl: '',
        // facebookUrl: '',
        ContactURL: 'https://beamashal.com/',
    },

    {
        paintingId: 'W11V01',
        videoId: 'W11V01',
        standaloneVideoElementId: 'W11V01',
        videoURL: 'W11V01.mp4',
        headerText: `<h5></h5>`,
        bodyText: ``,
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE | ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
        displayMesh: 'N',
        // displayHeight: 90,
        videoAutoPlay: 'N',
        videoTextureEncoding: THREE.sRGBEncoding,
        useVideoMeshButton: 'Y',
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['W11V01INS', 'W11V01EN', 'W11V01FR', 'W11V01ES'],
        annotation_location: ANNOTATION_LOCATION.BOTTOM_RIGHT,
        annotation_location_horiz_offset: 0.04,
        annotation_location_vert_offset: 0.02,
    },
    {
        paintingId: 'W11V01INS',
        videoId: null,
        videoURL: 'W11V01.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
        headerText: null,
        bodyText: `<b>ENG/US</b> Click the yellow arrows to move between languages<br><b>FR</b> Cliquez sur les flèches jaunes pour déplacer entre les langues<br><b>ES</b> Haga clic en las flechas amarillas para moverse entre idiomas`,
    },
    {
        paintingId: 'W11V01EN',
        videoId: null,
        videoURL: 'W11V01.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
        headerText: `<h5>Lujain Jo</h5><h6>(She/Her)</h6>`,
        bodyText: `<b>ENG/US</b> <i>Lujain Jo</i> is an Iraqi filmmaker, activist, and performance artist. She has a strong interest in the manifestations of movement in life, and her work includes collaborations with musicians and dancers.<br><br>This short video was created for International Women's Day in 2020 as Lujain wasn't able to join the Women's March. It combines footage of her friends and women she cares about from these streets as a tribute to them and as a tribute to the feminist activists. In the end of the video the late feminist activist, Nadine Jouni, appears from a shot Lujain took of her years ago. Nadine fought for the right of women to have custody of their children after a divorce. Nadine passed away weeks before the revolution and in the video we hear her colleagues and fellow activists call her name in the streets where she walked. This video highlights the role women play in the streets to fight for our rights. It is a way to archive the chants that were called in the streets for generations later to know that women weren't quiet; they fought back against the laws and societies that oppress them.<br><br>Lujain says: "When I was a kid I was warned about behaving in certain ways so I won't be called "street girl/ بنت شارع". I used to think of the word as a negative thing until I grew up and met the most amazing women in the streets and realized that "street girls / بنات الشارع" are the best kind of women. They're the ones who fight for their rights and the rights of others. Some of them fight until the day they die and even after then, their fights are continued by other women. I was so proud to have walked the streets with these women and document their fights against a patriarchal society and its unfair laws.`,
        instagramUrl: 'http://www.vimeo.com/lujainjo',
        // facebookUrl: '',
        // ContactURL: '',
        urlLink1Label: 'VIMEO',
        urlLink1: 'http://www.vimeo.com/lujainjo',
    },
    {
        paintingId: 'W11V01FR',
        videoId: null,
        videoURL: 'W11V01.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
        headerText: `<h5>Lujain Jo</h5><h6>(She/Her)</h6>`,
        bodyText: `<b>FR</b> <i>Lujain Jo</i> est une cinéaste, activiste et artiste de performance irakienne. Elle s'intéresse vivement aux manifestations du mouvement dans la vie quotidienne. Son travail comprend des collaborations avec des musiciennes et des danseuses.<br><br>Cette courte vidéo a été créée pour la Journée internationale de la femme en 2020, car Lujain n'a pas pu rejoindre la Marche des femmes. Ce travail combine des images des amies de l’auteure et d’autres femmes qui lui tiennent à cœur pour leur combat dans les rues. La pièce représente un hommage à ces femmes et aux militantes féministes. À la fin de la vidéo, la militante féministe décédée Nadine Jouni apparaît sur une photo que Lujain lui avait prise il y a quelques années. Nadine s'est battue pour le droit des femmes à avoir la garde de leurs enfants après un divorce. Nadine est décédée quelques semaines avant la révolution. Dans la vidéo, nous entendons ses amies et ses collègues militantes prononcer son nom dans les rues où elle marchait. Cette vidéo met en lumière le rôle que jouent les femmes dans les rues lorsqu’elles luttent pour nos droits. C'est une façon d'archiver les slogans prononcés dans les rues pendant des générations. De cette manière on remarquera plus tard que les femmes n'étaient pas silencieuses ; elles se sont battues contre des lois et des sociétés qui les opprimaient.<br><br>Lujain nous raconte : « Quand j'étais enfant, on m'a appris à me comporter d'une certaine manière si je ne voulais pas être considérée comme une fille de la rue / بنتشارع. J'avais l'habitude de penser à cette expression comme quelque chose de négatif jusqu'à ce que j’aie grandi et que j’aie rencontré les femmes les plus extraordinaires dans les rues. C’est alors que j’ai réalisé que les filles de la rue / بنات الشارع étaient en réalité les femmes les plus précieuses. Celles qui se battent pour leurs droits et pour les droits d’autrui. Certaines d'entre elles se battent jusqu'à leur dernier souffle et même au-delà, car leurs combats sont poursuivis par d'autres femmes. J'étais très fière d'avoir marché dans les rues avec ces femmes et de documenter leurs combats contre une société patriarcale aux lois injustes ».`,
        instagramUrl: 'http://www.vimeo.com/lujainjo',
        // facebookUrl: '',
        // ContactURL: '',
        urlLink1Label: 'VIMEO',
        urlLink1: 'http://www.vimeo.com/lujainjo',
    },
    {
        paintingId: 'W11V01ES',
        videoId: null,
        videoURL: 'W11V01.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
        headerText: `<h5>Lujain Jo</h5><h6>(She/Her)</h6>`,
        bodyText: `<b>ES</b> <i>Lujain Jo</i> es una cineasta iraquí que es activista y artista de interpretación. Está muy interesada en las manifestaciones mediante movimiento y colabora con músicos y bailarines para realizar su trabajo.<br><br>Lujain creó este breve vídeo para el día Internacional de la Mujer en 2020, ya que no pudo participar en la marcha de las mujeres. El vídeo mezcla imágenes de sus amigas y de las mujeres que le importan y que paseaban por esas calles y es un homenaje a ellas y un tributo a las activistas feministas. Al final del vídeo aparece la difunta activista feminista Nadine Jouni, tomada de una foto que Lujain le hizo hace años. Al final del vídeo aparece la activista feminista Nadine Jouni, ya fallecida, de una toma que Lujain le hizo hace años. Nadine falleció semanas antes de la revolución y en el vídeo se escucha a sus compañeras y a otras activistas gritar su nombre en las calles por las que caminaba. Este vídeo resalta el papel que las mujeres desempeñan en las calles para luchar por nuestros derechos. Es una forma de que los cánticos que se entonaban en las calles perduren y que las generaciones posteriores sepan que las mujeres no se quedaron calladas; lucharon contra las leyes y las sociedades que las oprimen.<br><br>Lujain afirma: "Cuando era pequeña me advertían de que ciertos comportamientos podrían hacer que me llamaran "una mujer de la calle/ بنت شارع". Lo consideraba algo negativo hasta que crecí y en la calle, conocí a las mujeres más increíbles. Me di cuenta de que las "mujeres de la calle/ تانب عراشلا son las mejores de todas las mujeres. Son las que luchan por sus derechos y por los de los demás. Algunas luchan hasta el día de su muerte e incluso después, su lucha la continúan otras mujeres. Me sentí muy orgullosa de haber recorrido las calles con estas mujeres y haber documentado su luchas contra una sociedad patriarcal con leyes injustas".`,
        instagramUrl: 'http://www.vimeo.com/lujainjo',
        // facebookUrl: '',
        // ContactURL: '',
        urlLink1Label: 'VIMEO',
        urlLink1: 'http://www.vimeo.com/lujainjo',
    },
    /* Video */

    /* Wall 1 */
    /* Wall 1 */

    /* Wall 2 */
    {
        paintingId: 'W02P01',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['W02P01INS', 'W02P01EN', 'W02P01FR', 'W02P01ES'],
    },
    {
        paintingId: 'W02P01INS',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W02P01.jpg/info.json`,
        headerText: null,
        bodyText: `<b>ENG/US</b> Click the yellow arrows to move between languages<br><b>FR</b> Cliquez sur les flèches jaunes pour déplacer entre les langues<br><b>ES</b> Haga clic en las flechas amarillas para moverse entre idiomas`,
    },
    {
        paintingId: 'W02P01EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W02P01.jpg/info.json`,
        headerText: `<h5>Monon Muntaka Shova</h5><h6>(She/Her)</h6>`,
        bodyText: `<b>ENG/US</b> <i>Monon</i> is a freelance photographer and filmmaker based in Bangladesh. As a storyteller, she documents social issues and cultures, and most of her work is centred on women.<br><br>This piece documents the mass protests organised by Feminists Across Generations outside of the National Parliament Building on 10 October 2020, in response to the brutal gang-rape of a woman in Noakhali, Bangladesh. People from different communities - students, political parties, activists, and feminists - came together to stand up and speak out to demand justice following the gang-rape and an end to rape culture in Bangladesh.<br><br>Monon says: "That day I took those photos because I myself am an activist and feminist and I always raise my voice about anything that is wrong and violates human rights."`,
        instagramUrl: 'https://www.instagram.com/mononmuntaka/',
        // facebookUrl: '',
        // ContactURL: '',
    },
    {
        paintingId: 'W02P01FR',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W02P01.jpg/info.json`,
        headerText: `<h5>Monon Muntaka Shova</h5><h6>(She/Her)</h6>`,
        bodyText: `<b>FR</b> <i>Monon</i> est une photographe et cinéaste indépendante résidant au Bangladesh. En tant que narratrice, elle documente les problèmes sociaux et culturels. À cette fin, la plupart de son travail est centré sur les femmes.<br><br>Cette pièce met en exergue les protestations massives organisées par les féministes de plusieurs générations à l'extérieur du bâtiment du Parlement national le 10 octobre 2020, en réponse à la brutalité du viol collectif subi par une femme à Noakhali, au Bangladesh. Des personnes de différentes communautés — étudiants, partis politiques, militants et féministes — se sont réunies lors de cette manifestation pour hausser la voix afin de demander justice contre ce viol collectif et contre la culture du viol au Bangladesh.<br><br>Monon signale : « Ce jour-là, j'ai pris ces photos car que je suis moi-même une militante et une féministe et j'élève toujours ma voix contre tout ce qui ne va pas et contre les violations des droits de l'homme ».`,
        instagramUrl: 'https://www.instagram.com/mononmuntaka/',
        // facebookUrl: '',
        // ContactURL: '',
    },
    {
        paintingId: 'W02P01ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W02P01.jpg/info.json`,
        headerText: `<h5>Monon Muntaka Shova</h5><h6>(She/Her)</h6>`,
        bodyText: `<b>ES</b> <i>Monon</i> es una fotógrafa y cineasta autónoma que reside en Bangladesh. Como narradora, documenta la cultura y la problemática social. La mayor parte de su obra se centra en las mujeres.<br><br>En este artículo quedan reflejadas las protestas masivas organizadas por Feminists Across Generations (Generaciones de feministas) en el exterior del Palacio Nacional el 10 de octubre de 2020, en respuesta a la brutal violación en grupo de una mujer en Noakhali, Bangladesh. Personas de distintos sectores: estudiantes, partidos políticos, activistas y feministas, se manifestaron para pedir justicia por la violación en grupo y poner fin a las violaciones en Bangladesh.<br><br>Según declara Monon: "Aquel día hice esas fotos porque soy activista y feminista y siempre alzo la voz ante todo que no se debe hacer e infringe los derechos humanos".`,
        instagramUrl: 'https://www.instagram.com/mononmuntaka/',
        // facebookUrl: '',
        // ContactURL: '',
    },

    {
        paintingId: 'W02P02',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['W02P02INS', 'W02P02EN', 'W02P02FR', 'W02P02ES'],
    },
    {
        paintingId: 'W02P02INS',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W02P02.jpg/info.json`,
        headerText: null,
        bodyText: `<b>ENG/US</b> Click the yellow arrows to move between languages<br><b>FR</b> Cliquez sur les flèches jaunes pour déplacer entre les langues<br><b>ES</b> Haga clic en las flechas amarillas para moverse entre idiomas`,
    },
    {
        paintingId: 'W02P02EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W02P02.jpg/info.json`,
        headerText: `<h5>Ponclain Nzee</h5><h6>(He/Him)</h6>`,
        bodyText: `<b>ENG/US</b> <i>Ponclain</i> is a South Africa-based visual artist whose work is based on abstract contemporary portrait and bodypaint.<br><br>This piece explores Gender-Based Violence and Femicide; it encourages greater awareness and speaks out on the issues.<br><br>Ponclain says: "My vision is to create an art school to help learners to understand activism through art and be able to spread awareness."`,
        instagramUrl: 'https://www.instagram.com/ponclainzee_art/',
        // facebookUrl: '',
        // ContactURL: '',
    },
    {
        paintingId: 'W02P02FR',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W02P02.jpg/info.json`,
        headerText: `<h5>Ponclain Nzee</h5><h6>(He/Him)</h6>`,
        bodyText: `<b>FR</b> <i>Ponclain</i> est une artiste visuelle résidant en Afrique du Sud dont le travail est fondé sur la réalisation de portraits et peintures corporelles contemporaines et abstraites.<br><br>Son oeuvre explore les violences contre les femmes et les féminicides ; elle vise à encourager une plus grande prise de conscience et s'exprime sur les enjeux actuels.<br><br>Ponclain affirme : « Mon but est de créer une école artistique pour aider les étudiants à comprendre l'activisme à travers les arts et à devenir des personnes plus sensibilisées ».`,
        instagramUrl: 'https://www.instagram.com/ponclainzee_art/',
        // facebookUrl: '',
        // ContactURL: '',
    },
    {
        paintingId: 'W02P02ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W02P02.jpg/info.json`,
        headerText: `<h5>Ponclain Nzee</h5><h6>(He/Him)</h6>`,
        bodyText: `<b>ES</b> <i>Ponclain</i> es una artista visual que reside en Sudáfrica y su obra se basa en el retrato abstracto contemporáneo y el bodypaint.<br><br>Esta obra refleja la violencia de género y el feminicidio; fomenta una mayor concienciación y denuncia abiertamente estos temas.<br><br>Según declara Ponclain: "Mi objetivo es crear una escuela de arte que ayude a los alumnos a entender el activismo a través del arte para que puedan propagarlo".`,
        instagramUrl: 'https://www.instagram.com/ponclainzee_art/',
        // facebookUrl: '',
        // ContactURL: '',
    },
    /* Wall 2 */

    /* Wall 3 */
    {
        paintingId: 'W03P01',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['W03P01INS', 'W03P01EN', 'W03P01FR', 'W03P01ES'],
    },
    {
        paintingId: 'W03P01INS',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W03P01.jpg/info.json`,
        headerText: null,
        bodyText: `<b>ENG/US</b> Click the yellow arrows to move between languages<br><b>FR</b> Cliquez sur les flèches jaunes pour déplacer entre les langues<br><b>ES</b> Haga clic en las flechas amarillas para moverse entre idiomas`,
    },
    {
        paintingId: 'W03P01EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W03P01.jpg/info.json`,
        headerText: `<h5>Muntahana Sakhawat</h5><h6>(They/Them)</h6>`,
        bodyText: `<b>ENG/US</b> <i>Muntahana</i> is a painter who mixes realism and abstract.<br><br>This piece was originally created in 2018, but Muntahana decided to paint over the original piece at one point last year in quarantine, to reflect how they were feeling at the time: a burden to family and friends.<br><br>Muntahana says: "Flowers are considered a beautiful thing in our society; you give flowers to people you appreciate. I put these two feelings together and made this piece."`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
    },
    {
        paintingId: 'W03P01FR',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W03P01.jpg/info.json`,
        headerText: `<h5>Muntahana Sakhawat</h5><h6>(They/Them)</h6>`,
        bodyText: `<b>FR</b> <i>Muntahana</i> est une peintre qui combine le réalisme avec l'abstraction.<br><br>Cette pièce a été créée à l'origine en 2018, mais Muntahana a décidé de la retoucher lors de la quarantaine l'année dernière afin de refléter le ressenti général à cette époque : chaque individu était une source d'inquiétude pour sa famille et ses amis.<br><br>Muntahana explique : « Les fleurs sont considérées comme des objet précieux par nos sociétés ; on offre des fleurs aux gens qu’on apprécie. J'ai uni ces deux sentiments pour créer cette pièce ».`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
    },
    {
        paintingId: 'W03P01ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W03P01.jpg/info.json`,
        headerText: `<h5>Muntahana Sakhawat</h5><h6>(They/Them)</h6>`,
        bodyText: `<b>ES</b> <i>Muntahana</i> es una pintora que mezcla lo real con lo abstracto.<br><br>Esta obra se creó originalmente en 2018, pero Muntahana decidió pintar sobre la obra original en cierto momento de la pasada cuarentena para reflejar cómo se sentían en aquel momento: una carga para familia y amigos.<br><br>Según declara Muntahana: "Las flores significan belleza en nuestra sociedad, regalamos flores a las personas que apreciamos. Con esta mezcla de sentimientos creé esta obra".`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
    },

    {
        paintingId: 'W03P02',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['W03P02INS', 'W03P02EN', 'W03P02FR', 'W03P02ES'],
    },
    {
        paintingId: 'W03P02INS',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W03P02.jpg/info.json`,
        headerText: null,
        bodyText: `<b>ENG/US</b> Click the yellow arrows to move between languages<br><b>FR</b> Cliquez sur les flèches jaunes pour déplacer entre les langues<br><b>ES</b> Haga clic en las flechas amarillas para moverse entre idiomas`,
    },
    {
        paintingId: 'W03P02EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W03P02.jpg/info.json`,
        headerText: `<h5>Evelyn Kandin Geler</h5><h6>(She/Her)</h6>`,
        bodyText: `<b>ENG/US</b> <i>Evelyn</i> is a student of graphic design at the University of Buenos Aires and works as an illustrator.<br><br>Evelyn says: "My goal is to be able to connect, communicate, and inspire women with my illustrations. I want to be able to change their point of view of themselves, to empower them and help more people to shatter and redefine stereotypes."`,
        instagramUrl: 'https://www.instagram.com/accounts/login/',
        // facebookUrl: '',
        // ContactURL: '',
    },
    {
        paintingId: 'W03P02FR',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W03P02.jpg/info.json`,
        headerText: `<h5>Evelyn Kandin Geler</h5><h6>(She/Her)</h6>`,
        bodyText: `<b>FR</b> <i>Evelyn</i> est une étudiante en design graphique à l'université de Buenos Aires et elle travaille comme illustratrice.<br><br>Evelyn précise : « Mon objectif est de pouvoir connecter, communiquer et inspirer les femmes avec mes illustrations. J’aimerais changer leur point de vue sur elles-mêmes, leur donner du pouvoir puis aider plus de gens à briser et à redéfinir leurs stéréotypes ».`,
        instagramUrl: 'https://www.instagram.com/accounts/login/',
        // facebookUrl: '',
        // ContactURL: '',
    },
    {
        paintingId: 'W03P02ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W03P02.jpg/info.json`,
        headerText: `<h5>Evelyn Kandin Geler</h5><h6>(She/Her)</h6>`,
        bodyText: `<b>ES</b> <i>Evelyn</i> estudia diseño gráfico en la Universidad de Buenos Aires y trabaja como ilustradora.<br><br>Según declara Evelyn: "Mi objetivo es poder conectar con las mujeres, comunicarme con ellas e inspirarlas a través de mis ilustraciones. Me gustaría ser capaz de cambiarles su punto de vista y empoderarlas, ayudar a más gente a acabar con los estereotipos, redefinirlos".`,
        instagramUrl: 'https://www.instagram.com/accounts/login/',
        // facebookUrl: '',
        // ContactURL: '',
    },
    /* Wall 3 */

    /* Wall 4 */
    {
        paintingId: 'W04P01',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['W04P01INS', 'W04P01EN', 'W04P01FR', 'W04P01ES'],
    },
    {
        paintingId: 'W04P01INS',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W04P01.jpg/info.json`,
        headerText: null,
        bodyText: `<b>ENG/US</b> Click the yellow arrows to move between languages<br><b>FR</b> Cliquez sur les flèches jaunes pour déplacer entre les langues<br><b>ES</b> Haga clic en las flechas amarillas para moverse entre idiomas`,
    },
    {
        paintingId: 'W04P01EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W04P01.jpg/info.json`,
        headerText: `<h5>Mukuna Tshidibi</h5><h6>(He/Him)</h6>`,
        bodyText: `<b>ENG/US</b> <i>Mukuna</i> is an artist who uses illustration and animation.<br><br>In this piece he explores how people struggle with today's realities. It asks us to think about each other and feel what others are experiencing, specifically societal issues including Female Genital Mutilation, child marriage, Gender-Based Violence and bodily autonomy.`,
        instagramUrl: 'https://www.instagram.com/badartmukuna',
        // facebookUrl: '',
        ContactURL: 'https://www.artstation.com/badartmukuna',
    },
    {
        paintingId: 'W04P01FR',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W04P01.jpg/info.json`,
        headerText: `<h5>Mukuna Tshidibi</h5><h6>(He/Him)</h6>`,
        bodyText: `<b>FR</b> <i>Mukuna</i> est une artiste se servant de l'illustration et de l'animation.<br><br>Dans cette oeuvre, elle explore la manière dont les gens font face aux réalités actuelles. Son travail nous force à penser davantage les uns aux autres et à ressentir les sentiments d’autrui, en particulier en matière de conflits sociaux, tels que les mutilations sexuelles féminines, le mariage d'enfants, la violence contre les femmes et l'autonomie corporelle.`,
        instagramUrl: 'https://www.instagram.com/badartmukuna',
        // facebookUrl: '',
        ContactURL: 'https://www.artstation.com/badartmukuna',
    },
    {
        paintingId: 'W04P01ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W04P01.jpg/info.json`,
        headerText: `<h5>Mukuna Tshidibi</h5><h6>(He/Him)</h6>`,
        bodyText: `<b>ES</b> <i>Mukuna</i> es artista de ilustración y animación.<br><br>En esta obra refleja la lucha diaria de la población contra la realidad actual. Nos pide que reflexionemos sobre los demás y que sintamos lo que ellos sienten, sobre todo con respecto a cuestiones sociales como la mutilación genital femenina, el matrimonio infantil, la violencia de género y la autonomía corporal.`,
        instagramUrl: 'https://www.instagram.com/badartmukuna',
        // facebookUrl: '',
        ContactURL: 'https://www.artstation.com/badartmukuna',
    },

    {
        paintingId: 'W04P02',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['W04P02INS', 'W04P02EN', 'W04P02FR', 'W04P02ES'],
    },
    {
        paintingId: 'W04P02INS',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W04P02.jpg/info.json`,
        headerText: null,
        bodyText: `<b>ENG/US</b> Click the yellow arrows to move between languages<br><b>FR</b> Cliquez sur les flèches jaunes pour déplacer entre les langues<br><b>ES</b> Haga clic en las flechas amarillas para moverse entre idiomas`,
    },
    {
        paintingId: 'W04P02EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W04P02.jpg/info.json`,
        headerText: `<h5>Ipsita</h5><h6>(She/Her)</h6>`,
        bodyText: `<b>ENG/US</b> <i>Ipsita</i> is a feminist illustrator based in New Delhi, India. Her art captures the multifarious human emotions and sentiments. It consists of vibrant illustrations and realist portraits.<br><br>Ipsita uses her art to create key advocacy messages around gender equality as well as to grow a community of solidarity.`,
        instagramUrl: 'https://www.instagram.com/ipsitadivedi',
        // facebookUrl: '',
        ContactURL: 'https://www.ipsitadivedi.com',
    },
    {
        paintingId: 'W04P02FR',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W04P02.jpg/info.json`,
        headerText: `<h5>Ipsita</h5><h6>(She/Her)</h6>`,
        bodyText: `<b>FR</b> <i>Ipsita</i> est une illustratrice féministe résidant à New Delhi, en Inde. Son art capture la diversité des émotions et des sentiments humains. Son travail se compose d'illustrations émouvantes et de portraits réalistes.<br><br>Ipsita exploite son talent artistique pour créer des messages clés de plaidoyer autour de l'égalité des genres ainsi que pour promouvoir la solidarité dans nos sociétés.`,
        instagramUrl: 'https://www.instagram.com/ipsitadivedi',
        // facebookUrl: '',
        ContactURL: 'https://www.ipsitadivedi.com',
    },
    {
        paintingId: 'W04P02ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W04P02.jpg/info.json`,
        headerText: `<h5>Ipsita</h5><h6>(She/Her)</h6>`,
        bodyText: `<b>ES</b> <i>Ipsita</i> es una ilustradora feminista que vive en Nueva Delhi, India. Su arte capta la gran profusión de emociones y sentimientos humanos. Se compone de retratos realistas e ilustraciones llenas de vida.<br><br>Mediante su arte, Ipsita pretende crear mensajes clave de defensa de la igualdad de género, así como aumentar la solidaridad del pueblo.`,
        instagramUrl: 'https://www.instagram.com/ipsitadivedi',
        // facebookUrl: '',
        ContactURL: 'https://www.ipsitadivedi.com',
    },
    /* Wall 4 */

    /* Wall 5 */
    {
        paintingId: 'W05P01',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['W05P01INS', 'W05P01EN', 'W05P01FR', 'W05P01ES'],
    },
    {
        paintingId: 'W05P01INS',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W05P01.jpg/info.json`,
        headerText: null,
        bodyText: `<b>ENG/US</b> Click the yellow arrows to move between languages<br><b>FR</b> Cliquez sur les flèches jaunes pour déplacer entre les langues<br><b>ES</b> Haga clic en las flechas amarillas para moverse entre idiomas`,
    },
    {
        paintingId: 'W05P01EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W05P01.jpg/info.json`,
        headerText: `<h5>Rachel Watkins</h5><h6>(She/Her)</h6>`,
        bodyText: `<b>ENG/US</b> <i>Rachel</i> is an artist and a student based in Edinburgh, Scotland. She sells prints of her paintings with 50% of all profits going to Scottish Women's Aid, a charity working towards prevention of sexual abuse in Scotland.<br><br>This piece, Together Under One Sun, was created to empower and encapsulate a sense of unity between all women.<br><br>Rachel says: "I created this piece in the midst of the first lockdown when I was reflecting on all the amazing women in my life."`,
        instagramUrl: 'https://www.instagram.com/rachelastridart/',
        // facebookUrl: '',
        ContactURL: 'https://www.etsy.com/uk/shop/RachelAstridArt?ref=search_shop_redirect',
    },
    {
        paintingId: 'W05P01FR',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W05P01.jpg/info.json`,
        headerText: `<h5>Rachel Watkins</h5><h6>(She/Her)</h6>`,
        bodyText: `<b>FR</b> <i>Rachel</i> est une artiste et étudiante résidant à Édimbourg, en Écosse. Cette artiste vend des tirages de ses peintures et consacre 50 % de tous les bénéfices à l’organisation caritative Scottish Women's Aid [Secours aux femmes écossaises], qui œuvre pour la prévention des abus sexuels en Écosse.<br><br>La pièce présentée, Together Under One Sun [Sous un même soleil], vise à valoriser les femmes et à incarner un sentiment de sororité.<br><br>Rachel avoue : « J'ai créé cette pièce au milieu de la première période de confinement en pensant à toutes les femmes incroyables qui sont présentes dans ma vie ».`,
        instagramUrl: 'https://www.instagram.com/rachelastridart/',
        // facebookUrl: '',
        ContactURL: 'https://www.etsy.com/uk/shop/RachelAstridArt?ref=search_shop_redirect',
    },
    {
        paintingId: 'W05P01ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W05P01.jpg/info.json`,
        headerText: `<h5>Rachel Watkins</h5><h6>(She/Her)</h6>`,
        bodyText: `<b>ES</b> <i>Rachel</i> es una artista y estudiante afincada en Edimburgo, Escocia. Vende copias de sus cuadros y el 50% de los beneficios se destinan a Scottish Women's Aid (Ayuda para la mujer escocesa), una organización benéfica que lucha por evitar el abuso sexual en Escocia.<br><br>Esta obra, Together Under One Sun (Juntos bajo el mismo sol), se creó para potenciar y condensar un sentimiento de unidad entre todas las mujeres.<br><br>Según declara Rachel: "Creé esta obra en el primer confinamiento cuando me vi reflejada en todas las sorprendentes mujeres que hay en mi vida".`,
        instagramUrl: 'https://www.instagram.com/rachelastridart/',
        // facebookUrl: '',
        ContactURL: 'https://www.etsy.com/uk/shop/RachelAstridArt?ref=search_shop_redirect',
    },
    /* Wall 5 */

    /* Wall 6 */
    {
        paintingId: 'W06P01',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['W06P01INS', 'W06P01EN', 'W06P01FR', 'W06P01ES'],
    },
    {
        paintingId: 'W06P01INS',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W06P01.jpg/info.json`,
        headerText: null,
        bodyText: `<b>ENG/US</b> Click the yellow arrows to move between languages<br><b>FR</b> Cliquez sur les flèches jaunes pour déplacer entre les langues<br><b>ES</b> Haga clic en las flechas amarillas para moverse entre idiomas`,
    },
    {
        paintingId: 'W06P01EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W06P01.jpg/info.json`,
        headerText: `<h5>Kristine Chan</h5><h6>(They/Them)</h6>`,
        bodyText: `<b>ENG/US</b> <i>Kristine Chan</i> is a queer visual artist and designer from the Philippines. They work in both digital and traditional mediums, and find passion in combining art, design, storytelling and advocacy for progressive campaigns.<br><br>This piece, Stigma, is a contribution from the first year of Telling Truer Stories: An Art Anthology for Safe and Legal Abortion. It shows how a woman would feel given the current stigma around abortion and the lack of access to safe abortion.<br><br>Kristine is the co-founder and co-president of Filipino Freethinkers (FF), a civil society organisation that has been promoting reason, science, and secularism in the Philippines since 2009.`,
        instagramUrl: 'https://www.instagram.com/tintchan/',
        // facebookUrl: '',
        ContactURL: 'http://bit.ly/KristineChanArtistProfile',
    },
    {
        paintingId: 'W06P01FR',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W06P01.jpg/info.json`,
        headerText: `<h5>Kristine Chan</h5><h6>(They/Them)</h6>`,
        bodyText: `<b>FR</b> <i>Kristine Chan</i> est une artiste visuelle et designer queer originaire des Philippines. Elle travaille dans les médias numériques et traditionnels et combine de manière passionnée l'art, le design, la narration et la mobilisation pour créer des campagnes progressistes.<br><br>Cette pièce, Stigma, est une contribution correspondant à la première année du programme Telling Truer Stories: An Art Anthology for Safe and Legal Abortion [Racontez la vérité : Une anthologie artistique pour l'avortement légal et en toute sécurité]. Elle montre ce qu'une femme ressentirait face la stigmatisation actuelle autour de l'avortement et le manque d'accès à l'avortement sécurisé.<br><br>Kristine est cofondatrice et coprésidente de Filipino Freethinkers (FF) [Libre-penseuses philippines], une organisation de la société civile qui promeut la raison, la science et la laïcité aux Philippines depuis 2009.`,
        instagramUrl: 'https://www.instagram.com/tintchan/',
        // facebookUrl: '',
        ContactURL: 'http://bit.ly/KristineChanArtistProfile',
    },
    {
        paintingId: 'W06P01ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W06P01.jpg/info.json`,
        headerText: `<h5>Kristine Chan</h5><h6>(They/Them)</h6>`,
        bodyText: `<b>ES</b> <i>Kristine Chan</i> es una artista visual y diseñadora queer de Filipinas. Trabaja en medios tanto digitales como tradicionales y su pasión consiste en mezclar arte, diseño, narración y defensa de campañas progresistas.<br><br>Esta obra, Stigma (Estigma), es una contribución al primer año de Telling Truer Stories (Historias más reales): una antología artística sobre el aborto legal y seguro. Muestra cómo se sentiría una mujer ante el estigma que rodea al aborto actualmente y la imposibilidad para practicar un aborto seguro.<br><br>Kristine es cofundadora y copresidenta de Filipino Freethinkers (FF), una organización de la sociedad civil que promueve la razón, la ciencia y el laicismo en Filipinas desde 2009.`,
        instagramUrl: 'https://www.instagram.com/tintchan/',
        // facebookUrl: '',
        ContactURL: 'http://bit.ly/KristineChanArtistProfile',
    },

    {
        paintingId: 'W06P02',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['W06P02INS', 'W06P02EN', 'W06P02FR', 'W06P02ES'],
    },
    {
        paintingId: 'W06P02INS',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W06P02.jpg/info.json`,
        headerText: null,
        bodyText: `<b>ENG/US</b> Click the yellow arrows to move between languages<br><b>FR</b> Cliquez sur les flèches jaunes pour déplacer entre les langues<br><b>ES</b> Haga clic en las flechas amarillas para moverse entre idiomas`,
    },
    {
        paintingId: 'W06P02EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W06P02.jpg/info.json`,
        headerText: `<h5>Mohona Banerjee</h5><h6>(She/Her)</h6>`,
        bodyText: `<b>ENG/US</b> <i>Mohona</i> is an artist based in India. Through her artwork, she wants to deliver the message that women - regardless of body shapes and skin colours - are equal.<br><br>This piece is called FEMINIST because it depicts the different types of women belonging to different ethnicities and religions who are all equal in their rights.<br><br>Mohona says: "A woman could be straight or gay. A woman could dress whichever way she decides and not be judged for it. If she says no, it means no. It's time women are given equal importance and freedom to men."`,
        instagramUrl: 'https://www.instagram.com/painthues/?hl=en',
        // facebookUrl: '',
        // ContactURL: '',
    },
    {
        paintingId: 'W06P02FR',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W06P02.jpg/info.json`,
        headerText: `<h5>Mohona Banerjee</h5><h6>(She/Her)</h6>`,
        bodyText: `<b>FR</b> <i>Mohona</i> est une artiste d’origine indienne. À travers ses œuvres, elle veut partager un message : toutes les femmes, quelles que soient leur aspect corporel et leur couleur de peau, sont égales.<br><br>Cette pièce porte le titre FEMINIST [FÉMINISTE] car elle représente les différents types de femmes appartenant à des différentes ethnies et religions et nous rappelle qu’elles sont toutes égales en droits.<br><br>Mohona signale : « Une femme peut être hétéro ou gay. Une femme peut s'habiller comme elle l'entend et ne doit jamais être jugée pour cela. Lorsqu’elle dit non, cela veut dire non. Il est temps que les femmes aient la même importance et la même liberté que les hommes ».`,
        instagramUrl: 'https://www.instagram.com/painthues/?hl=en',
        // facebookUrl: '',
        // ContactURL: '',
    },
    {
        paintingId: 'W06P02ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W06P02.jpg/info.json`,
        headerText: `<h5>Mohona Banerjee</h5><h6>(She/Her)</h6>`,
        bodyText: `<b>ES</b> <i>Mohona</i> es una artista que vive en India. A través de sus obras, quiere enviar un mensaje: todas las mujeres, independientemente de la forma de su cuerpo y el color de su piel, somos iguales.<br><br>Esta obra se llama "FEMINIST" (FEMINISTA) porque representa los distintos tipos de mujeres que pertenecen a distintas etnias y religiones y que tienen los mismos derechos.<br><br>Según declara Mohona: "Una mujer puede ser heterosexual u homosexual. Puede vestir como quiera y que no se le juzgue por ello. Si dice no, significa no. Ya es hora de que las mujeres tengan la misma importancia y libertad que los hombres".`,
        instagramUrl: 'https://www.instagram.com/painthues/?hl=en',
        // facebookUrl: '',
        // ContactURL: '',
    },
    /* Wall 6 */

    /* Wall 7 */
    {
        paintingId: 'W07P01',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['W07P01INS', 'W07P01EN', 'W07P01FR', 'W07P01ES'],
    },
    {
        paintingId: 'W07P01INS',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W07P01.jpg/info.json`,
        headerText: null,
        bodyText: `<b>ENG/US</b> Click the yellow arrows to move between languages<br><b>FR</b> Cliquez sur les flèches jaunes pour déplacer entre les langues<br><b>ES</b> Haga clic en las flechas amarillas para moverse entre idiomas`,
    },
    {
        paintingId: 'W07P01EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W07P01.jpg/info.json`,
        headerText: `<h5>Amina Hossain</h5><h6>(She/Her)</h6>`,
        bodyText: `<b>ENG/US</b> <i>Amina</i> is an artist whose work symbolises how menstruation - often considered taboo in many cultures - is a natural part of a woman's life and therefore is beautiful.<br><br>Amina says: "Just as how flowers are considered beautiful and pure, menstruation is the same."`,
        // instagramUrl: '',
        // facebookUrl: '',
        ContactURL: 'https://late-nightmusings.carrd.co/',
    },
    {
        paintingId: 'W07P01FR',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W07P01.jpg/info.json`,
        headerText: `<h5>Amina Hossain</h5><h6>(She/Her)</h6>`,
        bodyText: `<b>FR</b> <i>Amina</i> est une artiste dont le travail vise à symboliser comment les menstruations — souvent considérées comme un tabou au sein de nombreuses cultures — font naturellement partie de la vie d'une femme et représentent donc un phénomène naturellement beau.<br><br>Amina nous explique : « Les règles devraient être considérées comme les fleurs : belles et pures ».`,
        // instagramUrl: '',
        // facebookUrl: '',
        ContactURL: 'https://late-nightmusings.carrd.co/',
    },
    {
        paintingId: 'W07P01ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W07P01.jpg/info.json`,
        headerText: `<h5>Amina Hossain</h5><h6>(She/Her)</h6>`,
        bodyText: `<b>ES</b> <i>Amina</i> es una artista cuya obra simboliza cómo la menstruación, que a menudo se considera tabú en muchas culturas, forma parte natural de la vida de una mujer y, por tanto, es algo hermoso.<br><br>Según dice Amina: "De la misma forma que se considera a las flores algo bello y puro, la menstruación es igual".`,
        // instagramUrl: '',
        // facebookUrl: '',
        ContactURL: 'https://late-nightmusings.carrd.co/',
    },

    {
        paintingId: 'W07P02',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['W07P02INS', 'W07P02EN', 'W07P02FR', 'W07P02ES'],
    },
    {
        paintingId: 'W07P02INS',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W07P02.jpg/info.json`,
        headerText: null,
        bodyText: `<b>ENG/US</b> Click the yellow arrows to move between languages<br><b>FR</b> Cliquez sur les flèches jaunes pour déplacer entre les langues<br><b>ES</b> Haga clic en las flechas amarillas para moverse entre idiomas`,
    },
    {
        paintingId: 'W07P02EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W07P02.jpg/info.json`,
        headerText: `<h5>Venessa Kaiser</h5><h6>(They/Them)</h6>`,
        bodyText: `<b>ENG/US</b> <i>Venessa</i> is an architect, artist and poet who uses any medium available. She practices mostly in nihilistic and surrealistic work. Her work is based on the perceptions of the human mind and the chaos it experiences for the contradictions of society, where we question our self-image and doubt our worth.<br><br>This piece, Identity, illustrates the concept of forced gender norms, body modification, social constraints on individuals who choose to be different.<br><br>Venessa says: "I wanted to use my art to remind of the significance of freedom of identity and protest breaking the peace of anyone's right to live as they please."`,
        instagramUrl: 'https://www.instagram.com/aesthesis.inc/?hl=en',
        facebookUrl: 'https://www.facebook.com/aesthesis.inc/',
        // ContactURL: '',
    },
    {
        paintingId: 'W07P02FR',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W07P02.jpg/info.json`,
        headerText: `<h5>Venessa Kaiser</h5><h6>(They/Them)</h6>`,
        bodyText: `<b>FR</b> <i>Venessa</i> est une architecte, artiste et poète dont le travail exploite tous les supports à sa disposition. Elle consacre principalement ses efforts aux travaux nihilistes et surréalistes. Son travail est basé sur les perceptions de l'esprit humain et sur le trouble ressenti à cause des contradictions de nos sociétés, qui nous forcent à remettre en question notre image et à douter de notre valeur.<br><br>Cette pièce, Identity [Identité], illustre le concept de normes de genre forcées, de modification corporelle, de contraintes sociales imposées à ceux qui choisissent d'être différents.<br><br>Venessa précise : « Je voulais utiliser mon art pour rappeler l'importance de la liberté d'identité et pour protester contre ceux qui refusent le droit de chacun de vivre comme il l’entend ».`,
        instagramUrl: 'https://www.instagram.com/aesthesis.inc/?hl=en',
        facebookUrl: 'https://www.facebook.com/aesthesis.inc/',
        // ContactURL: '',
    },
    {
        paintingId: 'W07P02ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W07P02.jpg/info.json`,
        headerText: `<h5>Venessa Kaiser</h5><h6>(They/Them)</h6>`,
        bodyText: `<b>ES</b> <i>Venessa</i> es arquitecta, artista y poeta y utiliza todos los medios que hay disponibles. Toca sobre todo el nihilismo y el surrealismo. Su obra se basa en las percepciones de la mente humana y el caos que experimenta debido a las contradicciones de la sociedad, que nos hace cuestionarnos nuestra propia imagen y dudar de nuestra valía.<br><br>Esta obra, Identity (Identidad), ilustra el concepto de las normas de género forzadas, los cambios que sufre el cuerpo y las restricciones sociales en las personas que eligen ser diferentes.<br><br>Según declara Vanesa: "A través de mi arte, he querido recordar el significado de la libertad de identidad y luchar para que cada uno viva como quiera sin que se perturbe su paz".`,
        instagramUrl: 'https://www.instagram.com/aesthesis.inc/?hl=en',
        facebookUrl: 'https://www.facebook.com/aesthesis.inc/',
        // ContactURL: '',
    },

    {
        paintingId: 'W07P03',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['W07P03INS', 'W07P03EN', 'W07P03FR', 'W07P03ES'],
    },
    {
        paintingId: 'W07P03INS',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W07P03.jpg/info.json`,
        headerText: null,
        bodyText: `<b>ENG/US</b> Click the yellow arrows to move between languages<br><b>FR</b> Cliquez sur les flèches jaunes pour déplacer entre les langues<br><b>ES</b> Haga clic en las flechas amarillas para moverse entre idiomas`,
    },
    {
        paintingId: 'W07P03EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W07P03.jpg/info.json`,
        headerText: `<h5>Ayreen Khan</h5><h6>(She/Her)</h6>`,
        bodyText: `<b>ENG/US</b> <i>Ayreen</i> is a visionary artist, writer and researcher. Her images are vivid, translating themes from world traditions such as Tasawwuf/Sufism, Thangka/Tibetan Buddhist painting, Tantra, Sacred Geometry, and Mandala (Spiritual/ritual symbolism from Abrahamic religions, Hinduism and Buddhism). Ayreen’s work depicts infinite forms within formless time and space, reflecting life stories and situations. Her art points at love, rage, grief, pain, violence, beauty, ugliness, pleasure, separation and unification.<br><br>This piece portrays her journey of becoming, from a single cell to becoming a human. This journey of becoming starts by understanding her female body, feeling the experiences on the body, through the sensory system and making sense with the logical mind. Female bodies experience the forces of the nature within and channel it in the atmosphere; a feminine power, a power that creates, nurtures and governs.<br><br>Ayreen says: "The highest authority is one’s own experience of truth. The only way to experience truth directly is to look within, to observe oneself."`,
        instagramUrl: 'https://www.instagram.com/ayreenkhan',
        // facebookUrl: '',
        ContactURL: 'https://ayreenkhan.com/',
    },
    {
        paintingId: 'W07P03FR',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W07P03.jpg/info.json`,
        headerText: `<h5>Ayreen Khan</h5><h6>(She/Her)</h6>`,
        bodyText: `<b>FR</b> <i>Ayreen</i> est une artiste, écrivaine et chercheuse visionnaire. Ses images sont vives, elles traduisent des thèmes de traditions mondiales telles que le tasawwuf/soufisme, la thangka/peinture bouddhiste tibétaine, le tantra, la géométrie sacrée et les mandales (symbolisme spirituel/rituels appartenant aux religions abrahamiques, à l'hindouisme et au bouddhisme). Le travail d’Ayreen dépeint des formes infinies dans un temps et un espace hors forme, reflétant des histoires de vie et des situations personnelles. Son art met l'accent sur l'amour, la rage, le chagrin, la douleur, la violence, la beauté, la laideur, le plaisir, la séparation et l'unification.<br><br>Cette pièce décrit son propre parcours depuis sa condition de cellule jusqu’à celle d’être humain. Ce long voyage débute lorsqu’elle commence à comprendre son corps féminin, à ressentir les expériences qui le traversent à travers le système sensoriel et à donner un sens à son esprit logique. D’après cette artiste, les corps féminins abritent les forces de la nature en leur sein et les canalisent vers l'atmosphère ; il s’agit donc d’un pouvoir féminin, un pouvoir qui crée, nourrit et gouverne le monde.<br><br>Ayreen déclare : « La plus haute autorité est notre propre expérience de la vérité. La seule façon de faire l'expérience directe de la vérité est de regarder à l'intérieur, de s'observer soi-même »."`,
        instagramUrl: 'https://www.instagram.com/ayreenkhan',
        // facebookUrl: '',
        ContactURL: 'https://ayreenkhan.com/',
    },
    {
        paintingId: 'W07P03ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W07P03.jpg/info.json`,
        headerText: `<h5>Ayreen Khan</h5><h6>(She/Her)</h6>`,
        bodyText: `<b>ES</b> <i>Ayreen</i> es una artista visionaria, escritora e investigadora. Sus imágenes son alegres y trasladan temas sobre tradiciones del mundo como por ejemplo, el tasawwuf/sufismo, la pintura thangka/budista tibetana, el tantra, la geometría sagrada y el mandala (simbolismo espiritual/ritual de las religiones abrahámicas, el hinduismo y el budismo). La obra de Ayreen representa formas infinitas dentro de un tiempo y un espacio sin forma que reflejan historias y situaciones de la vida. Su arte está enfocado hacia el amor, la rabia, la pena, el dolor, la violencia, la belleza, la fealdad, el placer, la separación y la unificación.<br><br>Esta obra retrata su recorrido desde que es una célula hasta que se convierte en un ser humando. Al comienzo del recorrido, se centra en la comprensión de su cuerpo femenino, en cómo se sienten las experiencias del cuerpo a través del sistema sensorial y la conexión con la mente lógica. El cuerpo femenino experimenta la fuerza de la naturaleza en su interior y la canaliza en la atmósfera; el poder femenino, una fuerza que crea, nutre y gobierna.<br><br>Según declara Ayreen: "La máxima autoridad es la propia experiencia de la verdad. La única forma de vivir la verdad en primera persona es mirar hacia dentro, observarse a uno mismo".`,
        instagramUrl: 'https://www.instagram.com/ayreenkhan',
        // facebookUrl: '',
        ContactURL: 'https://ayreenkhan.com/',
    },
    /* Wall 7 */

    /* Wall 8 */
    {
        paintingId: 'W08P01',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['W08P01INS', 'W08P01EN', 'W08P01FR', 'W08P01ES'],
    },
    {
        paintingId: 'W08P01INS',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W08P01.jpg/info.json`,
        headerText: null,
        bodyText: `<b>ENG/US</b> Click the yellow arrows to move between languages<br><b>FR</b> Cliquez sur les flèches jaunes pour déplacer entre les langues<br><b>ES</b> Haga clic en las flechas amarillas para moverse entre idiomas`,
    },
    {
        paintingId: 'W08P01EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W08P01.jpg/info.json`,
        headerText: `<h5>Aonkita Dey</h5><h6>(She/Her)</h6>`,
        bodyText: `<b>ENG/US</b> <i>Aonkita</i> is a recent high school graduate who is passionate about social justice and art. She finds herself most expressive when she is able to mix the two, creating art with messages portraying social injustices.<br><br>This piece explores child marriage. In it, a young girl waves goodbye to her friends as she walks home holding her father's hand. Little does she know that after reaching home, she'll be married off to a stranger and will be sent off to his home.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
    },
    {
        paintingId: 'W08P01FR',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W08P01.jpg/info.json`,
        headerText: `<h5>Aonkita Dey</h5><h6>(She/Her)</h6>`,
        bodyText: `<b>FR</b> <i>Aonkita</i> est une jeune diplômée du secondaire passionnée par la justice sociale et par les arts. Elle se sent plus expressive lorsqu'elle est capable de mélanger ces deux passions pour créer des œuvres d’art engagées dépeignant des injustices sociales.<br><br>Cette pièce explore le mariage d'enfants. On y voit une jeune fille dire au-revoir à ses amis alors qu'elle rentre chez elle en tenant la main de son père. Ce que la fille ignore c’est qu’une fois rentrée chez elle, elle sera mariée à un inconnu et devra déménager chez son mari.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
    },
    {
        paintingId: 'W08P01ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W08P01.jpg/info.json`,
        headerText: `<h5>Aonkita Dey</h5><h6>(She/Her)</h6>`,
        bodyText: `<b>ES</b> <i>Aonkita</i> se acaba de graduar en la escuela secundaria y le apasiona la justicia social y el arte. Su expresividad aumenta cuando es capaz de mezclar ambas disciplinas y crea arte con mensajes que retratan la injusticia social.<br><br>En esta obra se examina el matrimonio infantil. En ella, una joven se despide de sus amigos cuando camina hacia su casa de la mano de su padre. No sabe que cuando llegue a casa la obligarán a casarse con un desconocido y tendrá que irse a vivir con él.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
    },

    {
        paintingId: 'W08P02',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['W08P02INS', 'W08P02EN', 'W08P02FR', 'W08P02ES'],
    },
    {
        paintingId: 'W08P02INS',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W08P02.jpg/info.json`,
        headerText: null,
        bodyText: `<b>ENG/US</b> Click the yellow arrows to move between languages<br><b>FR</b> Cliquez sur les flèches jaunes pour déplacer entre les langues<br><b>ES</b> Haga clic en las flechas amarillas para moverse entre idiomas`,
    },
    {
        paintingId: 'W08P02EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W08P02.jpg/info.json`,
        headerText: `<h5>Laila Liza</h5><h6>(She/Her)</h6>`,
        bodyText: `<b>ENG/US</b> <i>Laila</i> is a student and an illustrator who likes to express her works through her art.<br><br>This piece was inspired by Laila's sister whose skin colour is naturally darker than Laila's, which has been the cause of insecurities for her sister.<br><br>Laila says: "I want every person in every society: does skin colour make people different?"`,
        instagramUrl: 'https://www.instagram.com/lailas_imagination',
        facebookUrl: 'https://www.facebook.com/lailaliza68',
        // ContactURL: '',
    },
    {
        paintingId: 'W08P02FR',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W08P02.jpg/info.json`,
        headerText: `<h5>Laila Liza</h5><h6>(She/Her)</h6>`,
        bodyText: `<b>FR</b> <i>Laila</i> est une étudiante et une illustratrice qui aime exprimer son talent artistique à travers ses travaux.<br><br>Cette pièce a été inspirée par sa sœur dont la couleur naturelle de peau est plus foncée que celle de Laila, ce qui a été une cause d'insécurité pour elle.<br><br>D’après Laila : « Je veux que chaque personne dans chaque société se pose cette question : la couleur de la peau rend-elle les gens différents?»`,
        instagramUrl: 'https://www.instagram.com/lailas_imagination',
        facebookUrl: 'https://www.facebook.com/lailaliza68',
        // ContactURL: '',
    },
    {
        paintingId: 'W08P02ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W08P02.jpg/info.json`,
        headerText: `<h5>Laila Liza</h5><h6>(She/Her)</h6>`,
        bodyText: `<b>ES</b> <i>Laila</i> es estudiante e ilustradora y le gusta expresar sus obras a través de su arte.<br><br>Esta obra está inspirada en la hermana de Laila, que tiene la piel más oscura que ella. Esto le ha causado muchos problemas de inseguridad.<br><br>Según declara Laila: "Yo acepto a todo el mundo de todas las sociedades: ¿el color de la piel hace que seas distinto?"`,
        instagramUrl: 'https://www.instagram.com/lailas_imagination',
        facebookUrl: 'https://www.facebook.com/lailaliza68',
        // ContactURL: '',
    },
    /* Wall 8 */

    /* Wall 9 */
    {
        paintingId: 'W09P02',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['W09P02INS', 'W09P02EN', 'W09P02FR', 'W09P02ES'],
    },
    {
        paintingId: 'W09P02INS',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W09P02.jpg/info.json`,
        headerText: null,
        bodyText: `<b>ENG/US</b> Click the yellow arrows to move between languages<br><b>FR</b> Cliquez sur les flèches jaunes pour déplacer entre les langues<br><b>ES</b> Haga clic en las flechas amarillas para moverse entre idiomas`,
    },
    {
        paintingId: 'W09P02EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W09P02.jpg/info.json`,
        headerText: `<h5>Moses Kas</h5><h6>(He/Him)</h6>`,
        bodyText: `<b>ENG/US</b> <i>Moses</i> is a graphic designer and visual artist who dedicates his art to sexual and reproductive health and rights activism.<br><br>Moses says: "Menstrual blood is the only source of blood that is not traumatically induced. Yet in modern society, this is rarely spoken of and almost never seen, except privately by women."`,
        instagramUrl: 'https://www.instagram.com/iammoseskas',
        // facebookUrl: '',
        // ContactURL: '',
    },
    {
        paintingId: 'W09P02FR',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W09P02.jpg/info.json`,
        headerText: `<h5>Moses Kas</h5><h6>(He/Him)</h6>`,
        bodyText: `<b>FR</b> <i>Moses</i> est un graphiste et un artiste visuel dont l’activité artistique est consacrée à la santé sexuelle et génésique et au militantisme pour les droits.<br><br>Selon Moses : « Le sang menstruel est la seule source de sang qui n’est pas induite par un traumatisme. Pourtant, dans nos sociétés modernes, on n'en parle que très rarement, c'est un phénomène qui n'est visible que dans la vie privée des femmes ».`,
        instagramUrl: 'https://www.instagram.com/iammoseskas',
        // facebookUrl: '',
        // ContactURL: '',
    },
    {
        paintingId: 'W09P02ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W09P02.jpg/info.json`,
        headerText: `<h5>Moses Kas</h5><h6>(He/Him)</h6>`,
        bodyText: `<b>ES</b> <i>Moses</i> es un diseñadora gráfica y artista visual y dedica su arte al activismo por la salud sexual y reproductiva así como sus derechos.<br><br>Según declara Moses: "La sangre de la menstruación es la única sangre que no tiene un origen traumático. Sin embargo, en la sociedad moderna, rara vez se habla sobre ella y casi nunca se ve, excepto las mujeres en privado".`,
        instagramUrl: 'https://www.instagram.com/iammoseskas',
        // facebookUrl: '',
        // ContactURL: '',
    },

    {
        paintingId: 'W09P03',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['W09P03INS', 'W09P03EN', 'W09P03FR', 'W09P03ES'],
    },
    {
        paintingId: 'W09P03INS',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W09P03.jpg/info.json`,
        headerText: null,
        bodyText: `<b>ENG/US</b> Click the yellow arrows to move between languages<br><b>FR</b> Cliquez sur les flèches jaunes pour déplacer entre les langues<br><b>ES</b> Haga clic en las flechas amarillas para moverse entre idiomas`,
    },
    {
        paintingId: 'W09P03EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W09P03.jpg/info.json`,
        headerText: `<h5>Vunene Somo</h5><h6>(She/Her)</h6>`,
        bodyText: `<b>ENG/US</b> <i>Vunene</i> is a South Africa-based artist. She has no preferred medium, but is partial to digital illustrations.<br><br>This piece, Cover Yourself, is an ode to all the women who only became uncomfortable with a characteristic of their body when someone who was not of their gender or even a remotely similar background commented on it.<br><br>Vunene says: "I like to work with pieces that are more subtle and are visually easing. I aim to represent the parts of myself and my heritage that remain hidden behind stereotypes. As a person who has experienced judgement for parts of my own body, my goal would be to one day be in a space when I could comfortably and openly take up the position in this illustration without any fear."`,
        instagramUrl: 'https://www.instagram.com/black.girl.drawing/',
        // facebookUrl: '',
        // ContactURL: '',
    },
    {
        paintingId: 'W09P03FR',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W09P03.jpg/info.json`,
        headerText: `<h5>Vunene Somo</h5><h6>(She/Her)</h6>`,
        bodyText: `<b>FR</b> <i>Vunene</i> est une artiste résidant en Afrique du Sud. Elle n'a pas de support de prédilection pour réaliser ses oeuvres, mais elle aime les illustrations numériques.<br><br>Cette pièce, Cover Yourself [Couvrez-vous], est une ode à toutes les femmes qui ont éprouvé le dégoût envers une partie de leur corps à cause de commentaires prononcés par des personnes du genre opposé ou appartenant à des contextes différents.<br><br>Vunene avoue : « J'aime travailler avec des pièces plus subtiles mais visuellement plus accessible. Je vise à représenter les parties de moi-même et de mon héritage qui restent cachées derrière des stéréotypes. En tant que personne qui a fait l'expérience du jugement sur certaines parties de mon corps, mon objectif serait d'être un jour dans un espace où je pourrais confortablement et ouvertement prendre position dans cette illustration sans éprouver aucune crainte ».`,
        instagramUrl: 'https://www.instagram.com/black.girl.drawing/',
        // facebookUrl: '',
        // ContactURL: '',
    },
    {
        paintingId: 'W09P03ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W09P03.jpg/info.json`,
        headerText: `<h5>Vunene Somo</h5><h6>(She/Her)</h6>`,
        bodyText: `<b>ES</b> <i>Vunene</i> es una artista afincada en Sudáfrica. No prefiere ningún medio, pero se inclina por las ilustraciones digitales.<br><br>Esta obra, Cover Yourself (Cúbrete), es una oda a todas las mujeres que sólo se han sentido incómodas con algún rasgo de su cuerpo cuando alguien del género opuesto o incluso de uno vagamente similar le ha hecho algún comentario.<br><br>Según declara Vunene: "Me gusta trabajar con obras más sutiles y de mayor sencillez visual. Pretendo representar las partes de mí misma y de mi legado que permanecen ocultas tras los estereotipos. Como persona que he sido juzgada por partes de mi propio cuerpo, mi objetivo sería estar algún día en un espacio en el que pudiera adoptar de forma cómoda y abierta la postura de esta ilustración sin ningún temor".`,
        instagramUrl: 'https://www.instagram.com/black.girl.drawing/',
        // facebookUrl: '',
        // ContactURL: '',
    },
    /* Wall 9 */

    /* Wall 10 */
    {
        paintingId: 'W10P01',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['W10P01INS', 'W10P01EN', 'W10P01FR', 'W10P01ES'],
    },
    {
        paintingId: 'W10P01INS',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W10P01.jpg/info.json`,
        headerText: null,
        bodyText: `<b>ENG/US</b> Click the yellow arrows to move between languages<br><b>FR</b> Cliquez sur les flèches jaunes pour déplacer entre les langues<br><b>ES</b> Haga clic en las flechas amarillas para moverse entre idiomas`,
    },
    {
        paintingId: 'W10P01EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W10P01.jpg/info.json`,
        headerText: `<h5>Isabella De la Mora</h5><h6>(She/Her)</h6>`,
        bodyText: `<b>ENG/US</b> <i>Isabella</i> currently lives and works between Mexico City and Ann Arbor, Michigan. Her work consists of a combination of process, action, expanded drawing, and registry, and the main media of her production is her own body. Her skin condition 'dermatographia' means any kind of contact causes a reaction. This mark means she "draws" on her skin to produce images and translate concepts. Her work plays with the idea of turning something ephemeral into something permanent.<br><br>This piece is inspired by the feminist movement in Mexico which fights against femicides and violence against women in Mexico. It includes two photographs that show the word "NO" marked on a woman's body - her body - to show that a woman's body can't be touched without consent. The poem follows this discourse. It is about raising voices against femicide and violence against women in Mexico, a country where the number of women murdered and subject to violence rises every day and the government does not pay attention.<br><br>Isabella says: "It is up to us, women, to speak together, to raise our voices and create together to bring awareness about it and do our part to protect each other."`,
        instagramUrl: 'https://www.instagram.com/isabelladelamorastudio/?hl=es',
        // facebookUrl: '',
        // ContactURL: '',
    },
    {
        paintingId: 'W10P01FR',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W10P01.jpg/info.json`,
        headerText: `<h5>Isabella De la Mora</h5><h6>(She/Her)</h6>`,
        bodyText: `<b>FR</b> <i>Isabella</i> vit et travaille actuellement entre le Mexique et la ville d’Ann Arbor, au Michigan. Son travail consiste en une combinaison de processus, d'action, de dessin élargi et de registre, et le principal média utilisé dans sa production est son propre corps. Son état cutané, connu sous le terme de « dermatographie », signifie que tout type de contact physique provoque une réaction sur sa peau. Elle « dessine » sur son corps des images traduisant des concepts. Ainsi, son travail joue avec l'idée de transformer quelque chose d'éphémère en quelque chose de permanent.<br><br>Cette pièce s'inspire du mouvement féministe au Mexique qui s’oppose aux féminicides et à la violence contre les femmes. Il comprend deux photographies montrant le mot « NO » [NON] inscrit sur le corps d'une femme — son propre corps — pour montrer que le corps de la femme ne peut pas être touché sans le consentement préalable de celle-ci. Le poème s’attache à ce discours. Il s'agit de hausser la voix contre les féminicides et contre la violence envers les femmes au Mexique, un pays où le nombre de femmes assassinées et de victimes de ce type de violence augmente chaque jour sans que le gouvernement n'y prête attention.<br><br>Comme précise Isabella : « C'est à nous, les femmes, de parler ensemble, d'élever nos voix et de créer ensemble pour en faire prendre conscience et apporter notre pierre à l'édifice pour nous protéger les unes les autres ».`,
        instagramUrl: 'https://www.instagram.com/isabelladelamorastudio/?hl=es',
        // facebookUrl: '',
        // ContactURL: '',
    },
    {
        paintingId: 'W10P01ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W10P01.jpg/info.json`,
        headerText: `<h5>Isabella De la Mora</h5><h6>(She/Her)</h6>`,
        bodyText: `<b>ES</b> <i>Isabella</i> vive y trabaja entre Ciudad de Méjico y Ann Arbor, Michigan. Su trabajo mezcla procesos, acción, dibujo ampliado y registro y su principal medio de producción es su propio cuerpo. El trastorno que tiene en la piel, "dermatografía" hace que cualquier tipo de contacto provoque una reacción. Esta marca significa que se "dibuja" en la piel para crear imágenes y traducir conceptos. Su obra juega con la idea de convertir algo efímero en algo definitivo.<br><br>Esta obra está inspirada en el movimiento feminista de Méjico que lucha contra los feminicidios y la violencia contra las mujeres en Méjico. Incluye dos fotografías que muestran la palabra "NO" escrita en el cuerpo de una mujer, su cuerpo, para explicar que no se puede tocar el cuerpo de una mujer sin su consentimiento. El poema sigue este discurso. Tenemos que protestar contra el feminicidio y la violencia contra las mujeres en Méjico, un país donde cada vez hay más mujeres asesinadas y que sufren la violencia, pero el gobierno no pone remedio.<br><br>Afirma Isabella: "Nos corresponde a nosotras, las mujeres, la tarea de expresarnos juntas, alzar la voz y crear obras juntas para concienciar sobre ello y poner de nuestra parte para protegernos unas a otras".`,
        instagramUrl: 'https://www.instagram.com/isabelladelamorastudio/?hl=es',
        // facebookUrl: '',
        // ContactURL: '',
    },
    /* Wall 10 */

    /* Wall 11 */
    /* Wall 11 */

    /* Wall 12 */
    {
        paintingId: 'W12P01',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['W12P01INS', 'W12P01EN', 'W12P01FR', 'W12P01ES'],
    },
    {
        paintingId: 'W12P01INS',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W12P01.jpg/info.json`,
        headerText: null,
        bodyText: `<b>ENG/US</b> Click the yellow arrows to move between languages<br><b>FR</b> Cliquez sur les flèches jaunes pour déplacer entre les langues<br><b>ES</b> Haga clic en las flechas amarillas para moverse entre idiomas`,
    },
    {
        paintingId: 'W12P01EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W12P01.jpg/info.json`,
        headerText: `<h5>Pamosays</h5><h6>(She/Her)</h6>`,
        bodyText: `<b>ENG/US</b> <i>Pamosays</i> is a photographer and videographer from Arunachal Pradesh, India. From a very young age, she observed that people don't truly listen. Through her studies of counselling psychology she has studied listening and helping people to feel heard, and she explores this through her art.<br><br>Pamosays says: "The lines from Phoebe Waller-Bridge's Crashing series, 'it's not useful for anyone to be ashamed of myself, they want to hate our bodies, that's how they control us,' changed the way I see myself. I now look at my naked self and I find myself sexy."`,
        instagramUrl: 'https://www.instagram.com/pamosays/',
        // facebookUrl: '',
        // ContactURL: '',
    },
    {
        paintingId: 'W12P01FR',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W12P01.jpg/info.json`,
        headerText: `<h5>Pamosays</h5><h6>(She/Her)</h6>`,
        bodyText: `<b>FR</b> <i>Pamosays</i> est une photographe et vidéaste originaire d'Arunachal Pradesh, en Inde. Dès son plus jeune âge, elle a remarqué que nous ne nous écoutons pas vraiment les uns les autres. À travers ses études en psychologie du conseil, elle a étudié comment être à l'écoute et aider les autres à se sentir écoutés, deux aspects qu’elle explore à travers son art.<br><br>Pamosays affirme : « Les mots de la série Crashing de Phoebe Waller-Bridge, "ce n'est utile pour personne d’avoir honte de soi-même. Ce qu’ils veulent c’est qu’on haïsse nos corps, car c'est comme ça qu'ils nous contrôlent ", ont changé la façon dont je me vois. Maintenant, lorsque je suis nue, je me regarde et me trouve sexy ».`,
        instagramUrl: 'https://www.instagram.com/pamosays/',
        // facebookUrl: '',
        // ContactURL: '',
    },
    {
        paintingId: 'W12P01ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W12P01.jpg/info.json`,
        headerText: `<h5>Pamosays</h5><h6>(She/Her)</h6>`,
        bodyText: `<b>ES</b> <i>Pamosays</i> es fotógrafa y videógrafa en Arunachal Pradesh, India. Desde muy joven observó que la gente, en realidad, no escuchaba. Gracias a su formación en psicología del asesoramiento, ha aprendido a escuchar y ayudar a los demás a escuchados, todo esto mediante su arte.<br><br>Pamosays afirma: "El argumento de Crashing de Phoebe Waller-Bridge, 'no beneficia a nadie avergonzarse de sí mismo, quieren odiar nuestros cuerpos y así, controlarnos', cambió mi forma de verme. Ahora me miro desnuda y me encuentro sexy".`,
        instagramUrl: 'https://www.instagram.com/pamosays/',
        // facebookUrl: '',
        // ContactURL: '',
    },
    /* Wall 12 */

    /* Wall 13 */
    {
        paintingId: 'W13P01',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['W13P01INS', 'W13P01EN', 'W13P01FR', 'W13P01ES'],
    },
    {
        paintingId: 'W13P01INS',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W13P01.jpg/info.json`,
        headerText: null,
        bodyText: `<b>ENG/US</b> Click the yellow arrows to move between languages<br><b>FR</b> Cliquez sur les flèches jaunes pour déplacer entre les langues<br><b>ES</b> Haga clic en las flechas amarillas para moverse entre idiomas`,
    },
    {
        paintingId: 'W13P01EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W13P01.jpg/info.json`,
        headerText: `<h5>Imameleng Masitha</h5><h6>(She/Her)</h6>`,
        bodyText: `<b>ENG/US</b> <i>Imameleng</i> is an activist and storyteller who uses the camera as a medium. She is driven by passion, grace and hard work to push the social justice agenda to the forefront. Her work mainly focuses on women and children.<br><br>Imameleng says: "Activist and many other womxn's stories are not documented. Every time we see a body of a person in a crime scene we call it either male or female. We seldom see names or call out names. People's names disappear. We need to name offenders and victims of femicide and stop identifying people with just sex organs."`,
        instagramUrl: 'https://www.instagram.com/imamelengeona/',
        // facebookUrl: '',
        // ContactURL: '',
    },
    {
        paintingId: 'W13P01FR',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W13P01.jpg/info.json`,
        headerText: `<h5>Imameleng Masitha</h5><h6>(She/Her)</h6>`,
        bodyText: `<b>FR</b> <i>Imameleng</i> est une activiste et une narratrice dont l’atout principal est sa caméra. Elle est animée par la passion, la grâce et le travail acharné pour faire passer le programme de justice sociale au premier plan. Son travail se concentre principalement sur les femmes et sur les enfants.<br><br>Selon Imameleng : « Les histoires des activistes et les histoires de nombreuses autres femmes ne sont pas documentées. Chaque fois que nous voyons le corps d'une personne sur une scène de crime, nous l'appelons un homme ou une femme. Pourtant, le nom de cette personne est très rarement disponible. Les noms des gens disparaissent. Nous devons nommer les délinquants et les victimes des féminicides et cesser d'identifier les personnes uniquement par leurs organes sexuels ».`,
        instagramUrl: 'https://www.instagram.com/imamelengeona/',
        // facebookUrl: '',
        // ContactURL: '',
    },
    {
        paintingId: 'W13P01ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W13P01.jpg/info.json`,
        headerText: `<h5>Imameleng Masitha</h5><h6>(She/Her)</h6>`,
        bodyText: `<b>ES</b> <i>Imameleng</i> es una activista y narradora que utiliza la cámara como medio. Se deja llevar por la pasión, la elegancia y el trabajo constante para priorizar el plan de acción de la justicia social. Su obra se centra sobre todo en las mujeres y los niños.<br><br>Imameleng afirma: "Las historias de las activistas y de muchas otras mujeres no están documentadas. Cada vez aparece un cuerpo en la escena del crimen lo definimos como hombre o mujer. Es raro que veamos nombres o los llamemos por sus nombres. Los nombres desaparecen. Tenemos que nombrar a los agresores y a las víctimas de feminicidio y dejar de identificar a las personas sólo por sus órganos sexuales".`,
        instagramUrl: 'https://www.instagram.com/imamelengeona/',
        // facebookUrl: '',
        // ContactURL: '',
    },
    /* Wall 13 */

    /* Wall 14 */
    {
        paintingId: 'W14P01',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['W14P01INS', 'W14P01EN', 'W14P01FR', 'W14P01ES'],
    },
    {
        paintingId: 'W14P01INS',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W14P01.jpg/info.json`,
        headerText: null,
        bodyText: `<b>ENG/US</b> Click the yellow arrows to move between languages<br><b>FR</b> Cliquez sur les flèches jaunes pour déplacer entre les langues<br><b>ES</b> Haga clic en las flechas amarillas para moverse entre idiomas`,
    },
    {
        paintingId: 'W14P01EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W14P01.jpg/info.json`,
        headerText: `<h5>Karren Barcita</h5><h6>(She, Her)</h6>`,
        bodyText: `<b>ENG/US</b> <i>Karren</i> is a Filipina erotic artist who explores sensuality and advocates for sex positivity and sex education through visual arts: collage art and photography.<br><br>This photo is from Karren's series (i)ntimacy which narrates her visual experience of what real intimacy feels like and how it can make one's sexuality a positive and liberating experience.<br><br>Karren says: "Being in touch with one's own sexuality has always been considered taboo in my conservative country. I learned about sex in a way where I sought pleasure not for myself but to please the opposite sex. In my own journey, a part of me was awakened to realise that sex is about pleasure for myself too."`,
        instagramUrl: 'https://www.instagram.com/antiqorno',
        // facebookUrl: '',
        ContactURL: 'http://www.yodibujoenmipiel.wordpress.com/',
    },
    {
        paintingId: 'W14P01FR',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W14P01.jpg/info.json`,
        headerText: `<h5>Karren Barcita</h5><h6>(She, Her)</h6>`,
        bodyText: `<b>FR</b> <i>Karren</i> est une artiste érotique philippine qui explore la sensualité et prône la positivité et l'éducation sexuelle à travers les arts visuels : depuis l'art du collage jusqu’à la photographie.<br><br>Cette photo est tirée de la série (i)ntimacy de Karren. Cette série raconte son expérience visuelle de ce que signifie la vraie intimité et comment elle peut faire d'une sexualité une expérience positive et libératrice.<br><br>Karren nous explique : « Être en contact avec sa propre sexualité a toujours été considéré comme un tabou dans la mentalité très conservatrice de mon pays. On m’a appris la sexualité comme une manière de rechercher le plaisir non pas pour moi mais pour la personne du sexe opposé. Lors de mon parcours personnel, une partie de moi s'est réveillée pour réaliser que le sexe est aussi une question de plaisir pour moi-même ».`,
        instagramUrl: 'https://www.instagram.com/antiqorno',
        // facebookUrl: '',
        ContactURL: 'http://www.yodibujoenmipiel.wordpress.com/',
    },
    {
        paintingId: 'W14P01ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W14P01.jpg/info.json`,
        headerText: `<h5>Karren Barcita</h5><h6>(She, Her)</h6>`,
        bodyText: `<b>ES</b> <i>Karren</i> es una artista filipina de erotismo que explora la sensualidad y aboga por la positividad y la educación sexuales a través de las artes visuales: el arte del collage y la fotografía.<br><br>Esta foto pertenece a la serie de Karren (i)ntimacy (intimidad), que narra su experiencia visual de lo que significa la intimidad real y cómo puede convertir la sexualidad propia una experiencia positiva y liberadora.<br><br>Karren afirma: El contacto con la propia sexualidad siempre se ha considerado un tabú en un país conservador como el mío. Conocí el sexo como una práctica en la que no buscaba mi propio placer, sino el del sexo opuesto. En mi propio recorrido, una parte de mí despertó para entender que el sexo también es un placer para mí".`,
        instagramUrl: 'https://www.instagram.com/antiqorno',
        // facebookUrl: '',
        ContactURL: 'http://www.yodibujoenmipiel.wordpress.com/',
    },

    {
        paintingId: 'W14P02',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['W14P02INS', 'W14P02EN', 'W14P02FR', 'W14P02ES'],
    },
    {
        paintingId: 'W14P02INS',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W14P02.jpg/info.json`,
        headerText: null,
        bodyText: `<b>ENG/US</b> Click the yellow arrows to move between languages<br><b>FR</b> Cliquez sur les flèches jaunes pour déplacer entre les langues<br><b>ES</b> Haga clic en las flechas amarillas para moverse entre idiomas`,
    },
    {
        paintingId: 'W14P02EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W14P02.jpg/info.json`,
        headerText: `<h5>Hayley-Claire Joseph</h5><h6>(She/Her)</h6>`,
        bodyText: `<b>ENG/US</b> <i>Hayley-Claire Joseph</i> is a photographer and a student who captures what she sees; from flowers, to people and still life photography. In addition her goals and ambition is to write films about Gender Based Violence and Crime in South Africa, hoping to motivate filmmakers and photographers to expand in this genre.<br><br>This piece explores the wider societal pressures on women. The woman sits in the sand and the spirits gives the illusion that society looks down on her and tries to ridicule her.<br><br>Hayley-Claire says: "My inspiration comes from my mentor, who gave me a reason to believe in myself and broadcast my art. My focus is to create awareness amongst our people especially the men in our society and that they should respect women."`,
        instagramUrl: 'https://www.instagram.com/hayley_c_joseph_photography/',
        facebookUrl: 'https://web.facebook.com/Hayley-C-Joseph-Photography-103560755191211/',
        // ContactURL: '',
    },
    {
        paintingId: 'W14P02FR',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W14P02.jpg/info.json`,
        headerText: `<h5>Hayley-Claire Joseph</h5><h6>(She/Her)</h6>`,
        bodyText: `<b>FR</b> <i>Hayley-Claire Joseph</i> est une photographe et une étudiante qui capture toute ce qui croise son regard : des fleurs, des personnes ou même des photographies de natures mortes. En outre, ses objectifs et son ambition sont d'écrire des films sur la violence et la criminalité contre les femmes en Afrique du Sud, dans l'espoir de motiver les cinéastes et les photographes à approfondir ce genre.<br><br>Cette pièce explore les pressions les plus intenses que la société exerce sur les femmes. La femme est assise sur le sable et les esprits donnent l'illusion que la société la méprise et essaie de la ridiculiser.<br><br>Selon Hayley-Claire : « Mon inspiration vient de mon mentor, qui m'a donné des arguments pour croire en mes talents et pour diffuser mon art. Mon objectif est de sensibiliser notre peuple, en particulier les hommes de notre société, afin qu'ils respectent les femmes ».`,
        instagramUrl: 'https://www.instagram.com/hayley_c_joseph_photography/',
        facebookUrl: 'https://web.facebook.com/Hayley-C-Joseph-Photography-103560755191211/',
        // ContactURL: '',
    },
    {
        paintingId: 'W14P02ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W14P02.jpg/info.json`,
        headerText: `<h5>Hayley-Claire Joseph</h5><h6>(She/Her)</h6>`,
        bodyText: `<b>ES</b> <i>Hayley-Claire Joseph</i> es fotógrafa y estudiante y captura lo que ve; desde flores hasta personas pasando por naturaleza muerta. Además, su objetivo y su sueño es escribir guiones para películas sobre la violencia de género y sobre el crimen en Sudáfrica para así, motivar a cineastas y fotógrafos a profundizar en este género.<br><br>Esta pieza se adentra en las presiones sociales más duras sobre las mujeres. La mujer se sienta en la arena y los espíritus crean la impresión de que la sociedad la desprecia e intenta ridiculizarla.<br><br>Hayley-Claire afirma: "Mi inspiración proviene de mi mentora, que me dio una razón para creer en mí misma y prodigar mi arte. Mi objetivo es convencer a nuestra gente, sobre todo a los hombres de nuestra sociedad, de que respeten a las mujeres".`,
        instagramUrl: 'https://www.instagram.com/hayley_c_joseph_photography/',
        facebookUrl: 'https://web.facebook.com/Hayley-C-Joseph-Photography-103560755191211/',
        // ContactURL: '',
    },

    {
        paintingId: 'W14P03',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['W14P03INS', 'W14P03EN', 'W14P03FR', 'W14P03ES'],
    },
    {
        paintingId: 'W14P03INS',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W14P03.jpg/info.json`,
        headerText: null,
        bodyText: `<b>ENG/US</b> Click the yellow arrows to move between languages<br><b>FR</b> Cliquez sur les flèches jaunes pour déplacer entre les langues<br><b>ES</b> Haga clic en las flechas amarillas para moverse entre idiomas`,
    },
    {
        paintingId: 'W14P03EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W14P03.jpg/info.json`,
        headerText: `<h5>Sarah Rose Smiley</h5><h6>(She/Her)</h6>`,
        bodyText: `<b>ENG/US</b> <i>Sarah Rose Smiley</i> is a multidisciplinary artist based in Boston, Massachusetts, USA. Art is her love language. She uses her foundation of a traditional approach to create something that follows fewer rules, and allows for more abstraction. Mirroring her own healing, her photography practice has evolved from one entrenched in and upholding idealised beauty standards to one that actively aims to disrupt them.<br><br>This photo is from a series created for survivors to recognise themselves in their own healing process after trauma. Society at large has a false understanding of what it means to be a survivor of sexual assault. Survivors do not have the privilege of seeing themselves in the media's current discourse of victimhood and survival; it is one-sided, lacking empathy and nuance, and incredibly harmful in its lack of agency and wholeness.<br><br>Sarah says: "I know from firsthand experience how this lack of recognition impairs healing. The lack of honest and holistic models of the non-linearity of healing after trauma prevents a true reclamation of identity for many survivors. We have to do better."`,
        instagramUrl: 'https://www.instagram.com/sarahrosesmiley/?hl=en',
        // facebookUrl: '',
        ContactURL: 'http://www.sarahrosesmiley.com/',
    },
    {
        paintingId: 'W14P03FR',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W14P03.jpg/info.json`,
        headerText: `<h5>Sarah Rose Smiley</h5><h6>(She/Her)</h6>`,
        bodyText: `<b>FR</b> <i>Sarah Rose Smiley</i> est une artiste multidisciplinaire résidant à Boston, au Massachusetts, États-Unis. L'art est sa langue d'amour. Elle utilise les fondements d’une approche traditionnelle pour une création qui suit moins les règles et qui permet plus d'abstraction. Reflétant sa propre guérison, sa pratique de la photographie est passée des normes d'une beauté ancrée et idéalisée à celui qui vise activement à les rompre.<br><br>Cette photo est tirée d'une série créée pour que les survivantes se reconnaissent dans leur propre processus de guérison après un traumatisme. La société dans son ensemble a une fausse idée de ce que signifie être une survivante d'agression sexuelle. Les survivantes n'ont pas le privilège de se regarder au sein du discours actuel des médias sur la victimisation et la survie ; tout ce dispositif est unilatéral, manquant d'empathie et de nuance, et incroyablement nocif par son manque de tact et d'intégrité.<br><br>Elle avoue : « Je sais par expérience de première main comment ce manque de reconnaissance nuit à la guérison. Le manque de modèles honnêtes et holistiques liés à la non-linéarité de la guérison après un traumatisme empêche une véritable réclamation d'identité pour de nombreuses survivantes. Nous devons tous mieux faire ».`,
        instagramUrl: 'https://www.instagram.com/sarahrosesmiley/?hl=en',
        // facebookUrl: '',
        ContactURL: 'http://www.sarahrosesmiley.com/',
    },
    {
        paintingId: 'W14P03ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W14P03.jpg/info.json`,
        headerText: `<h5>Sarah Rose Smiley</h5><h6>(She/Her)</h6>`,
        bodyText: `<b>ES</b> <i>Sarah Rose Smiley</i> es una artista multidisciplinar que vive en Boston, Massachusetts, Estados Unidos. El arte es su idioma para amar. Se vale de los cimientos de un enfoque tradicional para crear algo menos disciplinar y que permita una mayor abstracción. Como reflejo de su propia curación, su fotografía ha pasado de unos estándares de belleza idealizados y consolidados a unos que pretenden desmantelarlos de forma activa.<br><br>Esta foto pertenece a una serie creada para que los supervivientes se reconozcan en su propio proceso de curación tras un trauma. La sociedad, en general, no entiende bien lo que significa sufrir una agresión sexual. Las personas que la han sufrido no tienen el privilegio de verse a sí mismos participando en los medios como víctimas y supervivientes. Se trata de una falta unilateral de empatía y de matices y resulta increíblemente dañino por su falta de representación y de integridad.<br><br>Sarah afirma: "Sé por experiencia que esta falta de reconocimiento no favorece la cura. Si no existen modelos honestos y holísticos en un modelo común para la cura después de un trauma, muchos supervivientes nunca recuperarán la identidad. Tenemos que hacerlo mucho mejor".`,
        instagramUrl: 'https://www.instagram.com/sarahrosesmiley/?hl=en',
        // facebookUrl: '',
        ContactURL: 'http://www.sarahrosesmiley.com/',
    },
    /* Wall 14 */

    /* Vinyls Annotations */
    {
        paintingId: 'W00Y01',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['W00Y01INS', 'W00Y01FR', 'W00Y01ES'],
        displayMesh: 'N',
    },
    {
        paintingId: 'W00Y01INS',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: null,
        bodyText: `<b>ENG/US</b> Click the yellow arrows to move between languages<br><b>FR</b> Cliquez sur les flèches jaunes pour déplacer entre les langues<br><b>ES</b> Haga clic en las flechas amarillas para moverse entre idiomas`,
    },
    {
        paintingId: 'W00Y01FR',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: null,
        bodyText: `<b>FR</b> <i>Bienvenue à la galerie d'art SheDecides</i><br><br>La galerie d'art SheDecides vous présente 25 œuvres d'art de 25 artistes différentes, sélectionnées pour célébrer le 25ème anniversaire de la Déclaration et Programme d'action de Beijing pour l'égalité entre les hommes et les femmes.<br><br>Ces œuvres d'art agissent comme des pièces de conversation qui reflètent les principaux problèmes d'autonomie corporelle affectant la vie des femmes et des filles dans les communautés du monde entier.<br><br>Une 26e œuvre d'art — le manifeste de SheDecides — symbolise l'année qui vient de s'écouler, ayant fait dérailler les progrès sur l'égalité entre les hommes et les femmes et ayant érodé le droit des femmes à décider sur leur corps, leur vie et leur avenir. Il symbolise également l'espoir qui accompagne toute action collective, motivée par une indignation fondée sur des preuves et unie par l’engagement de transformer le monde en un endroit plus sain, solide et sûr.<br><br>Un espace pour explorer, expérimenter et s'engager avec la connexion entre l'art et l'activisme lié à l'autonomie corporelle. C'est à dire, un monde où ElleDécide [SheDecides]. Décidément.`,
    },
    {
        paintingId: 'W00Y01ES',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: null,
        bodyText: `<b>ES</b> <i>Os damos la bienvenida a la galería de arte SheDecides (Ella decide)</i><br><br>La galería de arte SheDecides presenta 25 obras de arte de 25 artistas, encargadas de conmemorar los 25 años desde la Declaración y Plataforma de Acción de Beijing sobre la igualdad de género.<br><br>Estas obras simbolizan fragmentos de conversaciones que reflexionan sobre las cuestiones clave de la autonomía corporal que afectan a la vida de las mujeres y niñas de comunidades de todo el mundo.<br><br>La obra de arte número 26, el manifiesto SheDecides, simboliza el año que acaba de pasar, que ha desbaratado los avances en materia de igualdad de género y ha minado el derecho de las mujeres a elegir sobre su cuerpo, su vida y su futuro. Pero también simboliza la esperanza que la acción colectiva conlleva, impulsada por la indignación basada en la evidencia y unida por el compromiso de un mundo mejor, más fuerte y más seguro.<br><br>Es un espacio por explorar y experimentar. Existe una conexión entre arte y activismo de la autonomía corporal para un mundo en el que Ella decide y tenemos que mostrar nuestro apoyo. Sin duda alguna.`,
    },

    // {
    //     paintingId: 'W01Y03',
    //     videoId: null,
    //     videoURL: null,
    //     hasCarouselAsParent: 'Y',
    //     carouselAnnotationSiblings: ['W01Y03INS', 'W01Y03EN', 'W01Y03FR', 'W01Y03ES'],
    // },
    // {
    //     paintingId: 'W01Y03INS',
    //     videoId: null,
    //     videoURL: null,
    //     isMediaUsed: 'N',
    //     headerText: null,
    //     bodyText: `<b>ENG/US</b> Click the yellow arrows to move between languages<br><b>FR</b> Cliquez sur les flèches jaunes pour déplacer entre les langues<br><b>ES</b> Haga clic en las flechas amarillas para moverse entre idiomas`,
    // },
    // {
    //     paintingId: 'W01Y03EN',
    //     videoId: null,
    //     videoURL: null,
    //     isMediaUsed: 'N',
    //     headerText: ``,
    //     bodyText: `<b>ENG/US</b> When She Decides The world is better, stronger, safer`,
    //     // instagramUrl: '',
    //     // facebookUrl: '',
    //     // ContactURL: '',
    // },
    // {
    //     paintingId: 'W01Y03FR',
    //     videoId: null,
    //     videoURL: null,
    //     isMediaUsed: 'N',
    //     headerText: ``,
    //     bodyText: `<b>FR</b> Quand C’est Elle qui Décide, le monde est un endroit plus sain, solide et sûr`,
    //     // instagramUrl: '',
    //     // facebookUrl: '',
    //     // ContactURL: '',
    // },
    // {
    //     paintingId: 'W01Y03ES',
    //     videoId: null,
    //     videoURL: null,
    //     isMediaUsed: 'N',
    //     headerText: ``,
    //     bodyText: `<b>ES</b> Si ella decide, el mundo será un lugar más bello, fuerte y seguro`,
    //     // instagramUrl: '',
    //     // facebookUrl: '',
    //     // ContactURL: '',
    // },
    // {
    //     paintingId: 'W02Y01',
    //     videoId: null,
    //     videoURL: null,
    //     hasCarouselAsParent: 'Y',
    //     carouselAnnotationSiblings: ['W02Y01INS', 'W02Y01FR', 'W02Y01ES'],
    //     displayMesh: 'N',
    //     annotation_location_horiz_offset: -0.08,
    // },
    // {
    //     paintingId: 'W02Y01INS',
    //     videoId: null,
    //     videoURL: null,
    //     isMediaUsed: 'N',
    //     headerText: null,
    //     bodyText: `<b>ENG/US</b> Click the yellow arrows to move between languages<br><b>FR</b> Cliquez sur les flèches jaunes pour déplacer entre les langues<br><b>ES</b> Haga clic en las flechas amarillas para moverse entre idiomas`,
    // },
    // {
    //     paintingId: 'W02Y01FR',
    //     videoId: null,
    //     videoURL: null,
    //     isMediaUsed: 'N',
    //     headerText: ``,
    //     bodyText: `<b>FR</b> «Au fond, cela me montre que je ne suis pas considérée comme un être humain »<br>Umama Zillur, jeune responsable chez SheDecides 25x25 résidant au Bangladesh`,
    //     // instagramUrl: '',
    //     // facebookUrl: '',
    //     // ContactURL: '',
    // },
    // {
    //     paintingId: 'W02Y01ES',
    //     videoId: null,
    //     videoURL: null,
    //     isMediaUsed: 'N',
    //     headerText: ``,
    //     bodyText: `<b>ES</b> "En el fondo, me indica que no se me ve como un ser humano"<br>Umama Zillur, joven líder de SheDecides 25x25 de Bangladesh`,
    //     // instagramUrl: '',
    //     // facebookUrl: '',
    //     // ContactURL: '',
    // },
    {
        paintingId: 'W02Y02',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['W02Y02INS', 'W02Y02EN', 'W02Y02FR', 'W02Y02ES'],
        displayMesh: 'N',
        annotation_location_horiz_offset: -0.08,
    },
    {
        paintingId: 'W02Y02INS',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: null,
        bodyText: `<b>ENG/US</b> Click the yellow arrows to move between languages<br><b>FR</b> Cliquez sur les flèches jaunes pour déplacer entre les langues<br><b>ES</b> Haga clic en las flechas amarillas para moverse entre idiomas`,
    },
    {
        paintingId: 'W02Y02EN',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: ``,
        bodyText: `<b>ENG/US</b> Umama was an organiser of the October 2020 Rage Against Rape marches in Dhaka, Bangladesh. She says that she is deeply enraged by the way that rape culture in Bangladesh is perpetuated by society and enabled by the state. It's a complex system of patriarchal values and social hierarchies that fail to prioritise the rights of women.<br><br>"At the core of it, it shows me I am not seen as human"<br>Umama Zillur, SheDecides 25x25 young leader from Bangladesh`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
    },
    {
        paintingId: 'W02Y02FR',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: ``,
        bodyText: `<b>FR</b> Umama était une organisatrice des marches Rage Against Rape [Indignation contre le viol] d'octobre 2020 à Dhaka, au Bangladesh. Elle dit qu'elle est profondément indignée par la façon dont la culture du viol au Bangladesh est perpétuée par la société et rendue possible par l'État. C'est un système complexe de valeurs patriarcales et de hiérarchies sociales qui ne donnent pas la priorité aux droits des femmes.<br><br>« Au fond, cela me montre que je ne suis pas considérée comme un être humain »<br>Umama Zillur, jeune responsable chez SheDecides 25x25 résidant au Bangladesh`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
    },
    {
        paintingId: 'W02Y02ES',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: ``,
        bodyText: `<b>ES</b> Umama fue una de las organizadoras de las marchas de Rage de octubre de 2020 contra las violaciones en Bangladesh. Declara que la enfurece profundamente ver cómo la sociedad perpetua la cultura de la violación en Bangladesh y cómo el Estado la promueve. Se trata de un complejo sistema de valores patriarcales y jerarquías sociales que no priorizan los derechos de las mujeres.<br><br>"En el fondo, me indica que no se me ve como un ser humano"<br>Umama Zillur, joven líder de SheDecides 25x25 de Bangladesh`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
    },
    {
        paintingId: 'W04Y01',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['W04Y01INS', 'W04Y01EN', 'W04Y01FR', 'W04Y01ES'],
        displayMesh: 'N',
        // annotation_location_vert_offset: -0.05,
        annotation_location_horiz_offset: -0.05,
    },
    {
        paintingId: 'W04Y01INS',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: null,
        bodyText: `<b>ENG/US</b> Click the yellow arrows to move between languages<br><b>FR</b> Cliquez sur les flèches jaunes pour déplacer entre les langues<br><b>ES</b> Haga clic en las flechas amarillas para moverse entre idiomas`,
    },
    {
        paintingId: 'W04Y01EN',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: null,
        bodyText: `<b>ENG/US</b> Meet Mariam, a young activist from Burkina Faso, fighting to End FGM/C in her community. So that she and girls like her have the right to choose about their bodies, lives and future.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        youtubeUrl: 'https://www.youtube.com/watch?v=DX5GW0iTug8',
    },
    {
        paintingId: 'W04Y01FR',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: null,
        bodyText: `<b>FR</b> Découvrez Mariam, une jeune militante du Burkina Faso en lutte pour mettre fin aux mutilations sexuelles féminines dans sa communauté. Afin que Mariam et d’autres filles comme elle aient le droit de décider sur leur corps, leur vie et leur avenir.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        youtubeUrl: 'https://www.youtube.com/watch?v=DX5GW0iTug8',
    },
    {
        paintingId: 'W04Y01ES',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: null,
        bodyText: `<b>ES</b> Conoce a Mariam, una joven activista de Burkina Faso que lucha por acabar con la mutilación genital femenina en su comunidad. Para que ella y las demás niñas tengan derecho a elegir sobre su cuerpo, su vida y su futuro.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        youtubeUrl: 'https://www.youtube.com/watch?v=DX5GW0iTug8',
    },
    {
        paintingId: 'W04Y02',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['W04Y02INS', 'W04Y02EN', 'W04Y02FR', 'W04Y02ES'],
        displayMesh: 'N',
        annotation_location_vert_offset: -0.07,
    },
    {
        paintingId: 'W04Y02INS',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: null,
        bodyText: `<b>ENG/US</b> Click the yellow arrows to move between languages<br><b>FR</b> Cliquez sur les flèches jaunes pour déplacer entre les langues<br><b>ES</b> Haga clic en las flechas amarillas para moverse entre idiomas`,
    },
    {
        paintingId: 'W04Y02EN',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: null,
        bodyText: `<b>ENG/US</b> Women and girls are subject to harmful practices because they do not have the right to decide what happens to their bodies.<br><br>Today, there are more than 200 million survivors of FGM/C, many facing serious long-term physical and mental health consequences as a result of this trauma.​<br><br>Meet the young activists leading the fight against FGM/C`,
        urlLink1Label: 'SHEDECIDES',
        urlLink1: 'https://www.shedecides.com/taking-charge-the-young-activists-leading-the-fight-against-fgm-c',
    },
    {
        paintingId: 'W04Y02FR',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: null,
        bodyText: `<b>FR</b> Les femmes et les filles sont soumises à des pratiques préjudiciables parce qu'elles n'ont pas le droit de décider sur leur corps.<br><br>Aujourd'hui, il y a plus de 200 millions de survivantes des mutilations sexuelles féminines, dont beaucoup sont confrontées à de graves conséquences à long terme sur leur santé physique et mentale à la suite de ce traumatisme.`,
        urlLink1Label: 'SHEDECIDES',
        urlLink1: 'https://www.shedecides.com/taking-charge-the-young-activists-leading-the-fight-against-fgm-c',
    },
    {
        paintingId: 'W04Y02ES',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: null,
        bodyText: `<b>ES</b> Las mujeres y las niñas son objeto de prácticas nocivas porque no tienen derecho a decidir lo que pasa con su cuerpo.<br><br>En la actualidad, hay más de 200 millones de supervivientes de la MGF/C, muchas de las cuales se enfrentan a graves consecuencias a largo plazo para su salud física y mental como resultado de este trauma. Conoce a las jóvenes activistas que lideran la lucha contra la MGF/C`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        urlLink1Label: 'SHEDECIDES',
        urlLink1: 'https://www.shedecides.com/taking-charge-the-young-activists-leading-the-fight-against-fgm-c',
    },
    {
        paintingId: 'W05Y01',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['W05Y01INS', 'W05Y01FR', 'W05Y01ES'],
        displayMesh: 'N',
    },
    {
        paintingId: 'W05Y01INS',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: null,
        bodyText: `<b>ENG/US</b> Click the yellow arrows to move between languages<br><b>FR</b> Cliquez sur les flèches jaunes pour déplacer entre les langues<br><b>ES</b> Haga clic en las flechas amarillas para moverse entre idiomas`,
    },
    {
        paintingId: 'W05Y01FR',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: null,
        bodyText: `<b>FR</b> D'une voix audacieuse et catégorique, nous appelons à une action collective de rupture pour défier ceux qui restreignent le droit des femmes à décider sur leurs vies et sur leurs corps.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
    },
    {
        paintingId: 'W05Y01ES',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: null,
        bodyText: `<b>ES</b> Con voz firme y sin disculpas, hagamos un llamamiento a la acción colectiva revolucionaria para desafiar a quienes restringen el derecho de las mujeres derecho a decidir`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
    },
    {
        paintingId: 'W06Y01',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['W06Y01INS', 'W06Y01EN', 'W06Y01FR', 'W06Y01ES'],
        displayMesh: 'N',
        annotation_location_horiz_offset: -0.04,
    },
    {
        paintingId: 'W06Y01INS',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: null,
        bodyText: `<b>ENG/US</b> Click the yellow arrows to move between languages<br><b>FR</b> Cliquez sur les flèches jaunes pour déplacer entre les langues<br><b>ES</b> Haga clic en las flechas amarillas para moverse entre idiomas`,
    },
    {
        paintingId: 'W06Y01EN',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: null,
        bodyText: `<b>ENG/US</b> It’s time to create a world that is better, stronger, safer. A world where SheDecides about her body, life and future.<br><br>​Safe abortion is essential healthcare and outdated, colonial laws restricting abortions, along with harmful social stigmas imposed on women, will continue to place women’s lives and health at risk.​<br><br>​Join the Philippine Safe Abortion Advocacy Network, women's rights organizations, reproductive health advocates and youth advocates  in signing this petition to demand Filipino women have access to safe, legal abortion: “Save Women’s Lives: Decriminalize Abortion Now!”​`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        urlLink1Label: 'CHANGE.ORG',
        urlLink1: 'https://www.change.org/p/philippine-house-of-representatives-save-women-s-lives-decriminalize-abortion-now-aade3888-6fbf-4a3a-857d-78c2a716db90?use_react=false',

    },
    {
        paintingId: 'W06Y01FR',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: null,
        bodyText: `<b>FR</b> Il est temps de transformer notre monde en un endroit plus sain, solide et sûr. Un monde où ElleDécide sur son corps, sa vie et son avenir.<br><br>L’avortement sécurisé est un système de soins de santé essentiel. Pourtant, des lois coloniales obsolètes restreignant les avortements, ainsi que les marques d’infamie sociales imposés aux femmes, continueront de mettre la vie et la santé des femmes en danger.<br><br>Rejoignez le Philippine Safe Abortion Advocacy Network [Réseau pour la défense de l'avortement sécurisé aux Philippines], les organisations de défense des droits des femmes, les défenseurs de la santé reproductive et les défenseurs des jeunes en signant cette pétition pour exiger que les femmes philippines aient accès à un avortement sûr et légal : « Sauvez la vie des femmes : Décriminalisez l'avortement!»`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        urlLink1Label: 'CHANGE.ORG',
        urlLink1: 'https://www.change.org/p/philippine-house-of-representatives-save-women-s-lives-decriminalize-abortion-now-aade3888-6fbf-4a3a-857d-78c2a716db90?use_react=false',
    },
    {
        paintingId: 'W06Y01ES',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: null,
        bodyText: `<b>ES</b> Ha llegado el momento de crear un mundo mejor, más fuerte y más seguro. Un mundo en el que ella decida sobre su cuerpo, su vida y su futuro.<br><br>El aborto seguro es un servicio sanitario esencial. Las leyes coloniales y obsoletas que restringen los abortos, junto con los estigmas sociales que se les imponen a las mujeres, seguirán poniendo en riesgo sus vidas y su salud.<br><br>Únete a la Red filipina de defensa del aborto seguro, a las organizaciones de derechos de la mujer, a los defensores de la salud reproductiva y a los jóvenes que lo defienden y firma esta petición para y exigir que las mujeres filipinas puedan abortar de forma segura y legal: "Salva la vida de las mujeres: ¡Despenalización para el aborto ya!"`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        urlLink1Label: 'CHANGE.ORG',
        urlLink1: 'https://www.change.org/p/philippine-house-of-representatives-save-women-s-lives-decriminalize-abortion-now-aade3888-6fbf-4a3a-857d-78c2a716db90?use_react=false',
    },
    {
        paintingId: 'W09Y01',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['W09Y01INS', 'W09Y01EN', 'W09Y01FR', 'W09Y01ES'],
        displayMesh: 'N',
    },
    {
        paintingId: 'W09Y01INS',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: null,
        bodyText: `<b>ENG/US</b> Click the yellow arrows to move between languages<br><b>FR</b> Cliquez sur les flèches jaunes pour déplacer entre les langues<br><b>ES</b> Haga clic en las flechas amarillas para moverse entre idiomas`,
    },
    {
        paintingId: 'W09Y01EN',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: null,
        bodyText: `<b>ENG/US</b> In early 2021, SheDecides Senegal launched a period poverty roadshow which aims to bring 7000 reusable sanitary napkins to women and girls in each of Senegal's 14 regions. #MbaaxCiJaam​<br><br>Le combat continue!<br><br>Find out more below`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        urlLink1Label: 'FIND-OUT-MORE',
        urlLink1: 'https://en.diapci.sn/campaign/11/serviettes-hygieniques-reutilisables',
        twitterUrl: 'https://twitter.com/ShedecidesS/status/1355251865940844546?s=20',
    },
    {
        paintingId: 'W09Y01FR',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: null,
        bodyText: `<b>FR</b> Début 2021, SheDecides Sénégal a lancé un roadshow sur la pauvreté liée aux menstruations visant à apporter 7000 serviettes hygiéniques réutilisables aux femmes et aux filles dans chacune des 14 régions du Sénégal. #MbaaxCiJaam<br><br>Le combat continue!<br><br>En savoir plus`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        urlLink1Label: 'EN-SAVOIR-PLUS',
        urlLink1: 'https://fr.diapci.sn/campaign/11/serviettes-hygieniques-reutilisables',
        twitterUrl: 'https://twitter.com/ShedecidesS/status/1355251865940844546?s=20',
    },
    {
        paintingId: 'W09Y01ES',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: null,
        bodyText: `<b>ES</b> A principios de 2021, SheDecides Senegal puso en marcha una gira promocional sobre la pobreza relacionada con la menstruación para llevar 7.000 compresas reutilizables a mujeres y niñas de cada una de las 14 regiones de Senegal. #MbaaxCiJaam<br><br>¡El combate continúa!<br><br>Más información`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        urlLink1Label: `MÁS-INFORMACIÓN`,
        urlLink1: 'https://fr.diapci.sn/campaign/11/serviettes-hygieniques-reutilisables',
        twitterUrl: 'https://twitter.com/ShedecidesS/status/1355251865940844546?s=20',

    },
    {
        paintingId: 'W10Y01',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['W10Y01INS', 'W10Y01EN', 'W10Y01FR', 'W10Y01ES'],
        displayMesh: 'N',
        annotation_location_horiz_offset: -0.02,
        annotation_location_vert_offset: 0.1,
    },
    {
        paintingId: 'W10Y01INS',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: null,
        bodyText: `<b>ENG/US</b> Click the yellow arrows to move between languages<br><b>FR</b> Cliquez sur les flèches jaunes pour déplacer entre les langues<br><b>ES</b> Haga clic en las flechas amarillas para moverse entre idiomas`,
    },
    {
        paintingId: 'W10Y01EN',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: null,
        bodyText: `<b>ENG/US</b> Bodily autonomy is the right to decide what we do with our bodies, and what does or does not happen to our bodies. When we have bodily autonomy, we have the power and freedom to make decisions about our wellbeing; our relationships and our futures; and we are supported to fulfil those decisions free from fear and judgement.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
    },
    {
        paintingId: 'W10Y01FR',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: null,
        bodyText: `<b>FR</b> L'autonomie corporelle est le droit de décider de ce que nous faisons de notre corps et de ce qui arrive ou non à notre corps. Lorsque nous avons une autonomie corporelle, nous avons le pouvoir et la liberté de prendre des décisions concernant notre bien-être ; nos relations et notre avenir ; et nous sommes soutenues pour accomplir ces décisions sans peur ni jugement.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
    },
    {
        paintingId: 'W10Y01ES',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: null,
        bodyText: `<b>ES</b> La autonomía corporal es el derecho a decidir lo que hacemos con nuestro cuerpo y lo que le pasa o no le pasa a nuestro cuerpo. Cuando tenemos autonomía corporal, tenemos el poder y la libertad de tomar decisiones sobre nuestro bienestar, nuestras relaciones y nuestro futuro.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
    },
    {
        paintingId: 'W11Y01',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['W11Y01INS', 'W11Y01FR', 'W11Y01ES'],
        displayMesh: 'N',
        annotation_location_horiz_offset: -0.02,
        annotation_location_vert_offset: -0.04,
    },
    {
        paintingId: 'W11Y01INS',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: null,
        bodyText: `<b>ENG/US</b> Click the yellow arrows to move between languages<br><b>FR</b> Cliquez sur les flèches jaunes pour déplacer entre les langues<br><b>ES</b> Haga clic en las flechas amarillas para moverse entre idiomas`,
    },
    {
        paintingId: 'W11Y01FR',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: null,
        bodyText: `<b>FR</b> «Il faut briser les préjudices<br>patriarcaux liés aux genres,<br>à la sexualité et à la manière<br>dont nous percevons nos corps ».<br><br>– Un puissant cri de ralliement prononcé au Liban`,
    },
    {
        paintingId: 'W11Y01ES',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: null,
        bodyText: `<b>ES</b> ''Debemos romper el estereotipo de patriarcado sobre el sexo. la sexualidad y la forma en que percibimos nuestros cuerpos.''<br><br>- Un potente grito de guerra desde el Líbano`,
    },

    {
        paintingId: 'W14Y02',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['W14Y02INS', 'W14Y02EN', 'W14Y02FR', 'W14Y02ES'],
        displayMesh: 'N',
        // annotation_location_vert_offset: -0.2,
        // annotation_location_horiz_offset: -0.8,
    },
    {
        paintingId: 'W14Y02INS',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: null,
        bodyText: `<b>ENG/US</b> Click the yellow arrows to move between languages<br><b>FR</b> Cliquez sur les flèches jaunes pour déplacer entre les langues<br><b>ES</b> Haga clic en las flechas amarillas para moverse entre idiomas`,
    },
    {
        paintingId: 'W14Y02EN',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: null,
        bodyText: `<b>ENG/US</b> “We need to speak more openly about the stigma that survivors of sexual harassment face. Survivor centred justice is elusive and often conflated with ‘investigations’ and ‘closing cases’. It is easy for survivors to become pawns in those processes. We need to use our seat at the table to demand new, kinder processes that can ensure transparency and fairness while guaranteeing to protect women as they come forward and throughout the journey.<br><br>Malayah Harper, SheDecides Champion`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
    },
    {
        paintingId: 'W14Y02FR',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: null,
        bodyText: `<b>FR</b> «Nous devons parler plus ouvertement de la stigmatisation que subissent les victimes du harcèlement sexuel. Les formes de justice centrées sur les femmes survivantes sont trop évasives et sont souvent associées à des « enquêtes » et des « dossiers à clore ». Il est donc facile pour les survivantes de devenir des pions dans ce genre de processus. Nous devons taper sur la table pour exiger de nouveaux processus plus empathiques et qui garantissent la transparence et l'équité, en assurant la protection des femmes tout au long ce parcours depuis qu’elles dénoncent l’abus ».<br><br>Malayah Harper, championne SheDecides`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
    },
    {
        paintingId: 'W14Y02ES',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: null,
        bodyText: `<b>ES</b> Tenemos que hablar más abiertamente del estigma al que se enfrentan las supervivientes del acoso sexual. La justicia centrada en el superviviente es escurridiza y a menudo se confunde con "investigaciones" y "casos que se archivan". Es fácil que las supervivientes se conviertan en peones en esos procesos. Tenemos que utilizar nuestro puesto para exigir procesos nuevos y más condescendientes que puedan asegurar la transparencia y la equidad, garantizando al mismo tiempo la protección de las mujeres cuando presentan el caso y durante todo el proceso.<br><br>Malayah Harper, Primer premio de SheDecides`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
    },

    {
        paintingId: 'W14Y01',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['W14Y01INS', 'W14Y01EN', 'W14Y01FR', 'W14Y01ES'],
        displayMesh: 'N',
        // annotation_location_vert_offset: -0.2,
        annotation_location_horiz_offset: -0.08,
    },
    {
        paintingId: 'W14Y01INS',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: null,
        bodyText: `<b>ENG/US</b> Click the yellow arrows to move between languages<br><b>FR</b> Cliquez sur les flèches jaunes pour déplacer entre les langues<br><b>ES</b> Haga clic en las flechas amarillas para moverse entre idiomas`,
    },
    {
        paintingId: 'W14Y01EN',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: null,
        bodyText: `<b>ENG/US</b> We are moving forward, and we are not walking alone. Young feminist movements like SheDecides need to work with grassroot organisations and other activists across generations for gender equality. We must speak up, build inclusive narratives, make just laws, policies and services so that women and young people can finally decide about their bodies.`,
        urlLink1Label: `SHEDECIDES`,
        urlLink1: 'https://www.shedecides.com/25x25-new-normal-vision',

    },
    {
        paintingId: 'W14Y01FR',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: null,
        bodyText: `<b>FR</b> Nous avançons. Nous ne sommes pas seules. Les jeunes mouvements féministes comme SheDecides doivent collaborer avec des organisations de base et avec d'autres personnes militantes à travers les générations afin d’atteindre leur but : l'égalité des genres. À cette fin, nous devons prendre la parole, construire des récits inclusifs et proposer des lois, des politiques et des services justes afin que les femmes et les jeunes puissent enfin décider de leur corps. #TakeYourSeat [prenez place] et rejoignez-nous alors que nous approchons une nouvelle normalité. Une normalité où ElleDécide.`,
        urlLink1Label: `SHEDECIDES`,
        urlLink1: 'https://www.shedecides.com/25x25-new-normal-vision',
    },
    {
        paintingId: 'W14Y01ES',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: null,
        bodyText: `<b>ES</b> Estamos avanzando y caminamos solas. Los movimientos feministas jóvenes como SheDecides deben trabajar con las organizaciones populares y otros activistas de todas las generaciones por la igualdad de género. Debemos alzar la voz, crear una narrativa inclusiva, formular leyes, políticas y servicios justos para que las mujeres y las jóvenes puedan finalmente decidir sobre sus cuerpos. #Toma asiento y únete a nosotras, mientras actuamos por la nueva normalidad en la que ella decide.`,
        urlLink1Label: `SHEDECIDES`,
        urlLink1: 'https://www.shedecides.com/25x25-new-normal-vision',
    },
    /* Vinyls Annotations */
];

export {AnnotationsDB};
